var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, ElementRef, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from "../../shared/constants/common.constants";
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { Utils } from '../../shared/Utils/utils';
import { SSO } from '../../sso/sso.constants';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, RowStatus } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { StatusConstants } from '../constants/status.constants';
import { Translations } from '../constants/translations.constants';
import { CartTypes } from '../enums/cart-type.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { AddressType, OrderSourceType, OrderStatus, PaymentMethodTypes, PaymentType, PriceType, ProductWeightMetric, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, Source } from '../enums/order-source-type';
import { OrderSourceTypes, OrderSourceValue } from '../enums/order-source.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ShippingMemberTitle } from '../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { AddressService } from '../services/address.service';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { OrderService } from '../services/order.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { SponsorConfigService } from '../services/sponsor-config.service';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { MaskPipe } from 'ngx-mask';
import { GroupByPipe } from '../../common/pipes/group-by.pipe';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";
import { transactional } from '../enums/sponsor-transactional-source-type.enum';
var ServiceOrderComponent = /** @class */ (function () {
    function ServiceOrderComponent(_orderService, _sanitizer, _formbuilder, _http, _commonService, _translatePipe, _translateKey, _documentService, _currencyPipe, _cacheService, _customerService, messageService, _titleCase, _enrollmentMessageService, _shippingAddressInfoConfigService, _sponsorConfigService, _checkoutConfigService, _memberDisplayPriceConfigService, chRef, _appConfigService, _maskPipe, _groupByPipe, _personalInfoConfigService, _orderservice, _addressService) {
        var _this = this;
        this._orderService = _orderService;
        this._sanitizer = _sanitizer;
        this._formbuilder = _formbuilder;
        this._http = _http;
        this._commonService = _commonService;
        this._translatePipe = _translatePipe;
        this._translateKey = _translateKey;
        this._documentService = _documentService;
        this._currencyPipe = _currencyPipe;
        this._cacheService = _cacheService;
        this._customerService = _customerService;
        this.messageService = messageService;
        this._titleCase = _titleCase;
        this._enrollmentMessageService = _enrollmentMessageService;
        this._shippingAddressInfoConfigService = _shippingAddressInfoConfigService;
        this._sponsorConfigService = _sponsorConfigService;
        this._checkoutConfigService = _checkoutConfigService;
        this._memberDisplayPriceConfigService = _memberDisplayPriceConfigService;
        this.chRef = chRef;
        this._appConfigService = _appConfigService;
        this._maskPipe = _maskPipe;
        this._groupByPipe = _groupByPipe;
        this._personalInfoConfigService = _personalInfoConfigService;
        this._orderservice = _orderservice;
        this._addressService = _addressService;
        this.serviceOrderMemberDetails = new EventEmitter();
        this.orderFromLookupEmit = new EventEmitter();
        this.momentConstructor = moment.default || moment;
        this.showAddressFormValidations = false;
        this.memberTypeEnum = MemberTypeEnum;
        this.orderType = OrderType;
        this.deliveryPreference = DeliveryPreference;
        this.items = [];
        this.countries = [];
        this.memberCountries = [];
        this.agentAllowedCountries = [];
        this.states = [];
        this.memberSearchSubmitted = false;
        this.memberAddressDetails = [];
        this.memberShippingDetails = [];
        this.shipMethodValidation = '';
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.defaultCurrency = CommonConstant.Default_Currency;
        this.subTotal = 0.0;
        this.retailSubTotal = 0.0;
        this.totalCommissionableVolume = 0;
        this.selectedIsoCountryCode = '';
        this.selectedCountryCodeTwo = '';
        this.shippingMethods = [];
        this.products = [];
        this.isSubmitted = false;
        this.taxableAmount = 0;
        this.shippingCost = 0;
        this.orginalShippingCost = 0;
        this.shipMethod = {};
        this.showSelectedShipMethod = false;
        this.languageCode = 'en-US';
        this.languageShortCode = 'en';
        this.pollCount = 0;
        this.maxPollCount = 15;
        this.importFeeValue = 0;
        this.selectEnum = SelectEnum;
        this.datePickerStartDateAt = new Date();
        this.optInCheck = true;
        this.isMemberFboUpgraded = false;
        this.cityList = [];
        this.upgradeFboLimitExceeded = false;
        this.isFBOValidationPending = false;
        this.isWhosaleCheckNotCalculated = false;
        this.serviceOrderTypePermissions = [
            Permission.REPLACEMENT_ORDER_CREATE,
            Permission.REPLACEMENT_ORDER_MANAGE,
        ];
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.orderSession = {};
        this.enableBackDateOrder = false;
        this.isNewCard = false;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.existingItemCount = 0;
        this.memberCommunicationPreferences = {
            email: null,
            phone: false
        };
        this.showShippingAddress = true;
        this.isMemberHasAccessToOrder = true;
        this.restrictedDays = 0;
        this.cartLimitExceed = false;
        this.cartLimitNotReach = false;
        this.paymentTypeEnum = PaymentType;
        this.memberShippingDiscountOfferEligible = false;
        this.addressSearchResult = [];
        this.operatingCountries = [];
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.dropShipDeliveryOptionDisabled = false;
        this.hidePudoPickupLocationsButton = true;
        this.accountRestriction = false;
        this.accountRestrictionPermission = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
        this.accountViewPermission = false;
        this.accountRestrictedDisable = false;
        this.inActiveRecords = [];
        this.memberSearchValidation = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipOptionAvailable = false;
        this.dropshipPudoShippingMethod = null;
        this.isPickUpOptionExist = false;
        this.isDropShipOptionExist = false;
        this.scandinavianCountry = false;
        this.showDistance = false;
        /**
         * Checks Whether Order Can be BackDated or Not
         * @param timeZoneOffset
         */
        this.isBackDateOrderAvailable = function (timeZoneOffset) {
            _this._orderService.isBackDateOrderAllowed(timeZoneOffset, _this.countryCode).subscribe(function (response) {
                if (response && response.success) {
                    _this.enableBackDateOrder = true;
                }
                else {
                    _this.enableBackDateOrder = false;
                }
            });
        };
        // endregion
        // region #Start Products Section
        /**
        * @param  {any} data
        * @returns SafeHtml
        */
        this.autocompleListFormatter = function (data) {
            var html = "<span>" + data.itemNumber + " - " + _this._titleCase.transform(data.displayName ? data.displayName : data.name) + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        /**
         * Auto Complete Product Search
         */
        this.observableSource = function (keyword, fullSearch) {
            var fpc5PercentEnabled = false;
            if (_this.memberInfo && _this.serviceOrderPermissions && _this.storeInfo) {
                if (keyword && keyword.length > 1) {
                    if (keyword.indexOf('#') == 0) {
                        keyword = keyword.replace(/#/, '');
                    }
                    if (_this.appConfig && _this.appConfig.fpc5PercentEnabled) {
                        fpc5PercentEnabled = true;
                    }
                    var wholesaleQualified = _this.memberInfo && _this.memberInfo.wholeSaleQualified ? true : false;
                    if (wholesaleQualified == null) {
                        wholesaleQualified = false;
                    }
                    var optin = _this.memberInfo && _this.memberInfo.optin ? _this.memberInfo.optin : false;
                    /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
                        Level, Opt-In, and Wholesale Qualified Status*/
                    var memberTitleId = _this.memberInfo ? _this._orderService.getMemberTitleId(_this.memberInfo) : MemberLevel.RETAIL;
                    var purchaseFlowType = _this._commonService.getPurchaseFlowType(_this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    if (_this.memberInfo) {
                        memberTitleId = _this._orderService.getDowngradeTitleID(_this.memberInfo.memberTypeId, _this.memberInfo.memberTitleId);
                    }
                    var _itemNumberURL = environment.productsUrl + '/stores/' + _this.storeInfo.id + '/customerservice/products' +
                        '?languageCode=' + _this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                        '&countryCode=' + _this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                        + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                        '&optin=' + optin + '&taxInclusive=' + _this.storeInfo.taxInclusive;
                    if (fullSearch) {
                        _itemNumberURL += '&searchType=FULL';
                    }
                    return _this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(function (res) {
                        var results = res.json();
                        if (results && results.length > 0) {
                            return results;
                        }
                        else {
                            return [];
                        }
                    });
                }
                else {
                    return Observable.of([]);
                }
            }
            else {
                var notification = void 0;
                if (!_this.memberInfo) {
                    notification = _this._translatePipe.get('order.Member Details are Mandatory');
                }
                if (!_this.storeInfo && !_this.countryCode && !_this.pickupDeliveryOptionAvailable && !_this.shippingDeliveryOptionAvailable) {
                    notification = _this._translatePipe.get('Shipping options not available');
                }
                else if (!_this.storeInfo && !_this.countryCode &&
                    (_this.pickupDeliveryOptionAvailable || _this.shippingDeliveryOptionAvailable)) {
                    notification = _this._translatePipe.get('order.Country Details are Mandatory');
                }
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        };
    }
    ServiceOrderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.refSponsorId = null;
        this.shippingAddress = null;
        this.dropShipDeliveryOptionDisabled = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipOptionAvailable = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getAllPermissions();
        this.buildForm();
        this.getCountries();
        this.getStates();
        this.getOperatingCountries();
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.createOrderInfo = this._cacheService.get(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE);
        this._cacheService.remove(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        if (this.createOrderInfo) {
            this.orderFromLookup = true;
            this.fboid = this.createOrderInfo.distributorId;
            this.webOrderId = this.createOrderInfo.webOrderId;
            this.originalCountryCode = this.createOrderInfo.countryId;
            this.shoppingBagClicked = this.createOrderInfo.shoppingBagClicked;
        }
        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
            this.businessEntityId = this.orderSession.businessEntityId;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.deleteModal = new DeleteModal(this.clearData.bind(this), this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;
        this.orderFromLookup || this.isOrderSessionInfo || this.hasPersistedMemberId
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
            : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.subscribeSaveAddress();
        this.setPUDOSuggestedAddress();
        this.orderFormGroup.valueChanges.subscribe(function (formData) {
            if (formData.memberInfo && formData.memberInfo.length !== 0) {
                _this.onChanges(formData.memberInfo);
            }
        });
    };
    ServiceOrderComponent.prototype.clearData = function () {
    };
    ServiceOrderComponent.prototype.getFormControls = function () {
        var items = this.orderFormGroup.get('items');
        return items.controls;
    };
    ServiceOrderComponent.prototype.closeDeleteMessage = function () {
    };
    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof ServiceOrderComponent
    */
    ServiceOrderComponent.prototype.getAllPermissions = function () {
        this.serviceOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.serviceOrderTypePermissions + ']'), AccessLevel.Customer_Service);
    };
    //#region #Start Order Type Section
    ServiceOrderComponent.prototype.orderTypeChange = function (orderType) {
        this.orderTypePrevValue = orderType;
        this.updateCartProduct = 0;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.showShippingData = false;
            this.paymentComponentSettings.savedCards = [];
        }
        if (!this.isOrderSessionInfo) {
            this.hasPersistedMemberId ? this.clearAllTheForms(true, true) : this.clearAllTheForms(true, true, true);
        }
        else {
            this.clearAllTheForms();
        }
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    };
    //#region #Start Build Forms Section
    /**
     * build Form
     */
    ServiceOrderComponent.prototype.buildForm = function () {
        this.orderFormGroup = this._formbuilder.group({
            orderType: [OrderType.SERVICE_ORDER],
            memberInfo: [this.hasPersistedMemberId && this.fboid ? this.fboid : '', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            countryId: ['', [Validators.required]],
            deliveryPreference: [DeliveryPreference.DELIVERY],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.firstOption.toString()],
            paymentInstrumentId: [''],
            paymentSelector: [],
            backDateOrder: [false],
            saveForFutureUse: [false],
            language: [],
            isContactSponsor: [null],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]]
            // paymentMethodForm: this._formbuilder.array([this.createNewPaymentForm()])
        });
        this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
        this.buildPudoLocationSearchForm();
    };
    /**
     * set Distributor Info from FboId
     */
    ServiceOrderComponent.prototype.getDistributorInfo = function () {
        this.orderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    };
    ServiceOrderComponent.prototype.onKeydown = function (event) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    };
    /**
     * create item number
     * @returns FormGroup
     */
    ServiceOrderComponent.prototype.createItemNumberGroup = function () {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
        });
    };
    /**
    * ShippingAddressForm Intialize
    */
    ServiceOrderComponent.prototype.createNewShippingAddress = function () {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    };
    ServiceOrderComponent.prototype.getZipCodePatterns = function () {
        var _this = this;
        this._commonService.getZipCodePatterns().subscribe(function (response) {
            var zipCodePatterns = response;
            if (_this.selectedIsoCountryCode) {
                var pattern = zipCodePatterns.filter(function (x) { return x.isoCodeThree
                    === _this.selectedIsoCountryCode.toUpperCase(); })[0];
                _this.zipPattern = pattern ? pattern.zipPattern : null;
            }
        });
        return Validators.pattern(new RegExp(this.zipPattern));
    };
    ServiceOrderComponent.prototype.buildPudoLocationSearchForm = function (zipCode, city, addressLine1, country, externalId) {
        if (zipCode === void 0) { zipCode = ''; }
        if (city === void 0) { city = ''; }
        if (addressLine1 === void 0) { addressLine1 = ''; }
        if (country === void 0) { country = ''; }
        if (externalId === void 0) { externalId = ''; }
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        });
        var countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    };
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    ServiceOrderComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getCountriesLookup(true).subscribe(function (response) {
            if (response) {
                _this.countries = response;
                _this._cacheService.set(CacheKey.COUNTRIES, _this.countries);
                _this.stores = _this.countries.filter(function (country) { return country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled; });
                if (_this.originalCountryCode) {
                    _this.originalOrderCountry = _this.getCountryDetailsByCountryIdOrCode(null, _this.originalCountryCode);
                }
                if ((_this.orderFromLookup || _this.hasPersistedMemberId) && _this.fboid) {
                    _this.getDistributorInfo();
                }
                else if (_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['memberInfo'].setValue(_this.orderSession.memberInfo);
                    _this.searchMember();
                    _this.orderFormGroup.controls['orderType'].setValue(_this.orderSession.orderType);
                    _this.orderTypeChange(_this.orderFormGroup.controls['orderType'].value);
                }
                _this.orderFromLookup = _this.isOrderSessionInfo ? _this.orderSession.orderFromLookup : _this.orderFromLookup;
            }
        });
    };
    /**
     * To Get all operating countries from configuration service
     */
    ServiceOrderComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getAllOperatingCountries().subscribe(function (response) {
            if (response && response.length > 0) {
                _this.operatingCountries = response;
            }
            else {
                _this.operatingCountries = [];
            }
        }, function (error) {
            _this.operatingCountries = [];
        });
    };
    /**
     * get States
     */
    ServiceOrderComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    ServiceOrderComponent.prototype.getCountryDetailsByCountryIdOrCode = function (countryId, countryCode) {
        var countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter(function (x) { return x.countryId === countryId; })[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter(function (x) { return x.isocodeThree === countryCode; })[0];
        }
        return countryObj;
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    ServiceOrderComponent.prototype.getStateDetailsByStateIdOrCode = function (stateId, stateCode, countryCode) {
        var stateObj = {};
        if (stateId) {
            stateObj = this.states.filter(function (x) { return x.id === stateId; })[0];
        }
        if (stateCode && countryCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode && x.countryCode === countryCode; })[0];
        }
        else if (stateCode) {
            stateObj = this.states.filter(function (x) { return x.stateCode === stateCode; })[0];
        }
        return stateObj;
    };
    /**
     * On Country Select
     */
    ServiceOrderComponent.prototype.selectedCountry = function () {
        this.isWhosaleCheckNotCalculated = false;
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isMemberHasAccessToOrder = true;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        var selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            var countryObj = this.countries.filter(function (x) { return x.countryId === +selectedCountryID; })[0];
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.orderFormGroup.controls['countryId'].disable();
            if (countryObj) {
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState) {
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID, countryObj.countryId);
                    this.getCitiesByStates();
                }
                else {
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                if (this.memberInfo && this.memberInfo.memberId && this.checkoutConfig && this.checkoutConfig.displayBusinessEntity) {
                    this.loadMemberBasicInfo(this.memberInfo.memberId);
                }
                this.countryCode = countryObj.isocodeThree;
                this.showShippingData = true;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.storeInfo = null;
                this.sponsorConfig = this._sponsorConfigService.getSettings(countryObj.isocodeThree);
                this.storeId = 0;
                this._enrollmentMessageService.setStoreInfo(this.storeInfo);
                this.getStoreInfo(countryObj.isocodeThree);
                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
                    this.getParticipatingCountries(countryObj.isocodeThree);
                }
                if (this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                }
                this.clearAllTheForms(false);
                this.address = null;
                this.pudoAddress = null;
            }
        }
    };
    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    ServiceOrderComponent.prototype.getCartItemsByMemberAndCartTypeId = function (storeInfo, isSaveBagClicked) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, storeInfo)
            .subscribe(function (cartInfo) {
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCart = cartInfo;
                if (!_this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                    var productIds = cartInfo.items.map(function (x) { return x.productId; });
                    _this.getProductsByIds(productIds, storeInfo);
                }
            }
            else {
                _this.memberCart = null;
            }
        }, function (error) {
            new Error(error);
        });
    };
    ServiceOrderComponent.prototype.getCitiesByStates = function () {
        var _this = this;
        var countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe(function (response) {
            console.log(response);
            if (response) {
                _this.cityList = response;
                _this._cacheService.set(CacheKey.Cities, response);
            }
        });
    };
    /**
     * get products by Ids
     */
    ServiceOrderComponent.prototype.getProductsByIds = function (productsIds, storeInfo) {
        var _this = this;
        var fpc5PercentEnabled = false;
        var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        var purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(function (response) {
            if (response && response.length > 0) {
                if (_this.originalOrderDetail && _this.originalOrderDetail.orderLineItems) {
                    var orderLineItems = _this.originalOrderDetail.orderLineItems.map(function (x) { return x.productId; });
                    var responseProductId_1 = response.map(function (x) { return x.id; });
                    var inactiveProducts = orderLineItems.filter(function (item) { return responseProductId_1.indexOf(item) < 0; });
                    if (inactiveProducts) {
                        _this.inActiveRecords = [];
                        inactiveProducts.forEach(function (inactive) {
                            _this.originalOrderDetail.orderLineItems.forEach(function (element) {
                                if (element.productId == inactive) {
                                    _this.inActiveRecords.push(element.productName);
                                }
                            });
                        });
                    }
                }
                _this.loadproducts(response);
            }
            else {
                if (_this.originalOrderDetail && _this.originalOrderDetail.orderLineItems) {
                    _this.inActiveRecords = [];
                    _this.originalOrderDetail.orderLineItems.forEach(function (element) {
                        _this.inActiveRecords.push(element.productName);
                    });
                }
            }
            if (_this.inActiveRecords && _this.inActiveRecords.length >= 1) {
                _this.showInvalidConfigurationError();
            }
        });
    };
    ServiceOrderComponent.prototype.showInvalidConfigurationError = function () {
        var invalidConfigurationError = this._translatePipe.get('order.Product(s) are Inactive or Invalid Configuration ');
        var configError = '<b class="helvetica-bold">' + this.inActiveRecords.toString() + '</b> &nbsp;' + invalidConfigurationError.value;
        this._commonService.createNotification('', configError, NotificationType.ERROR);
    };
    /**
     *load procducts from session
     */
    ServiceOrderComponent.prototype.loadproducts = function (products) {
        var _this = this;
        products.forEach(function (product) {
            var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
            if (!isDepositFeeProduct) {
                _this.addItemNumber();
                var items = _this.orderFormGroup.get('items');
                if (items && items.length > 0) {
                    var index = (items.length - 1);
                    if (product) {
                        var itemValue = product.itemNumber + ' - ' + product.name;
                        items.controls[index].controls['itemNumber'].setValue(itemValue);
                        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                        var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                        items.controls[index].controls['productImage'].setValue(imageUrl);
                        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                        items.controls[index].controls['productId'].setValue(product.id);
                        items.controls[index].controls['productItem'].setValue(product);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (_this.isOrderSessionInfo) {
                            var productInfo = _this.orderSession.products.find(function (item) { return product.id === item.productId; });
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        }
                        else if (_this.originalOrderDetail) {
                            var productInfo = _this.originalOrderDetail.orderLineItems.find(function (item) { return product.id === item.productId; });
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        }
                        else if (_this.orderFormGroup && !_this.isOrderSessionInfo) {
                            var productInfo = null;
                            if (_this.memberCart && _this.memberCart.items.length > 0) {
                                productInfo = _this.memberCart.items.find(function (item) { return product.id === item.productId; });
                            }
                            items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        }
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo) {
            this.getShipMethods();
        }
    };
    /**
    * removing not available cart items based on logged in user
    * @param  {Cart} orderCart
    * @param  {CartItem[]} unAvailableCartItems
    */
    ServiceOrderComponent.prototype.deleteCart = function (sessionGuid) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid, this.storeInfo.id).subscribe(function (response) {
            });
        }
    };
    /**
     * @description constructing the schema form url
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.constructSchemaFormUrl = function (countryCode) {
        var _this = this;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(function () {
            _this.address = _this.address;
            _this.mailingAddress = _this.mailingAddress;
            _this.displayMailingAddressForm = true;
            _this.showAddressForm = true;
            _this.shippingDeliveryOptionAvailable = true;
        }, 500);
        this.orderFormGroup.controls['countryId'].enable();
    };
    // get existing shopping cart item count
    ServiceOrderComponent.prototype.getShoppingCartCount = function (storeInfo) {
        var _this = this;
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId, CartTypes.OrderCart, storeInfo)
            .subscribe(function (cartInfo) {
            _this.existingItemCount = 0;
            if (cartInfo && cartInfo.sessionGuid) {
                _this.memberCartInfo = cartInfo;
                _this.existingItemCount = 0;
                var cartItems = cartInfo.items;
                for (var index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                    _this.existingItemCount += cartItems[index].quantity;
                }
                _this.shoppingCartCount = _this.existingItemCount;
            }
            else {
                _this.existingItemCount = 0;
            }
        }, function (error) {
            new Error(error);
        });
    };
    /**
     * Get Store Info
     * @param countryCode
     */
    ServiceOrderComponent.prototype.getStoreInfo = function (countryCode) {
        var _this = this;
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
                if (response) {
                    _this.storeInfo = response;
                    var storeInfo_1 = response;
                    if (!_this.shoppingBagClicked && _this.orderFormGroup.value.orderType === _this.orderType.REGULAR && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST) {
                        _this.getShoppingCartCount(storeInfo_1);
                    }
                    _this.distributorMaxCC = storeInfo_1.distributorMaxCC;
                    if (_this.memberInfo && _this.memberInfo.fboId && _this.memberInfo.memberAllowedCountries
                        && _this.memberInfo.memberAllowedCountries.length > 0
                        && (+_this.memberInfo.memberTypeId === MemberTypeEnum.FPC || +_this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                        if (countryCode) {
                            _this.getWholsesaleQualifiedDetails(_this.memberInfo.fboId, countryCode, storeInfo_1);
                        }
                        else {
                            _this.getMemberDiscountPercentages(storeInfo_1);
                        }
                    }
                    else {
                        _this.getMemberDiscountPercentages(storeInfo_1);
                    }
                    _this.storeId = response.id;
                    _this.countryCode = countryCode;
                    _this.countryTaxInclusive = storeInfo_1.taxInclusive;
                    _this.shippingAddressInfoConfig = _this._shippingAddressInfoConfigService.getSettings(countryCode);
                    _this.appConfig = _this._appConfigService.getSettings(countryCode, _this.memberInfo); //storeConfiguration
                    _this.getOrderRules(storeInfo_1);
                    if (response.languages && response.languages.length > 0) {
                        _this.storeDefaultLanguage = response.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                        _this.languageShortCode = response.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
                    }
                    else {
                        _this.storeDefaultLanguage = _this.languageCode;
                    }
                    _this.getOrderDetails(storeInfo_1);
                    var memberType = void 0;
                    if (+_this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        if (_this.isOrderSessionInfo) {
                            _this.sponsorInformation = _this.orderSession.sponsorInformation;
                        }
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    }
                    else if (+_this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        _this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    //this.isBackDateOrderAvailable(response.timeZoneOffset);
                    var getDeliveryOptionsRequest = {
                        memberTypeId: _this.memberInfo ? _this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                        memberType: memberType.toUpperCase(),
                        source: Source.SERVICE,
                        countryCode: countryCode,
                        purchaseFlow: _this.deliveryOptionPurchaseFlow,
                        storeId: _this.storeId
                    };
                    _this.shippingDeliveryOptionAvailable = false;
                    _this.pickupDeliveryOptionAvailable = false;
                    _this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
                        if (res) {
                            _this.dropShipDeliveryOptionDisabled = false;
                            res.forEach(function (option) {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    _this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    _this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    if (option.optionDisabled) {
                                        _this.dropShipDeliveryOptionDisabled = true;
                                    }
                                    else if (_this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                        _this.dropShipOptionAvailable = true;
                                    }
                                    else {
                                        _this.pickupDeliveryOptionAvailable = true;
                                    }
                                }
                            });
                            var isDropShip = res.find(function (x) { return x.optionValue == DelivaryOptionType.Dropship; });
                            var isPickUp = res.find(function (x) { return x.optionValue == DelivaryOptionType.Pickup; });
                            if (environment.scandinavianCountries && _this.countryCode) {
                                var scandinavianCountries = environment.scandinavianCountries;
                                _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === _this.countryCode; });
                            }
                            // For Scandian country checking for Pickup
                            if (_this.scandinavianCountry && isPickUp) {
                                _this.isPickUpOptionExist = true;
                            }
                            // For Non-Scandian country checking for DropShip
                            if (!_this.scandinavianCountry && isDropShip && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && !_this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                _this.isDropShipOptionExist = true;
                            }
                            // For Non-Scandian country checking for PickUp
                            if (!_this.scandinavianCountry && isPickUp && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                _this.isPickUpOptionExist = true;
                            }
                            if (!_this.scandinavianCountry && isPickUp && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                _this.isPickUpOptionExist = true;
                            }
                            _this.storeInfo = storeInfo_1;
                            if (_this.memberInfo) {
                                _this.memberInfo = __assign({}, _this.memberInfo, { displayMiddleName: _this.storeInfo.displayMiddleName });
                            }
                            _this.storeInfo.ccNumberDecimals = 3;
                            _this.storeInfo.ccNumberFormat = 'CR';
                            _this.storeInfo.ccSymbol = 'CC';
                            _this.paymentComponentSettings.languageCode = _this.languageCode;
                            _this.paymentComponentSettings.storeId = _this.storeInfo.id;
                            _this.paymentComponentSettings.currencyCode = _this.storeInfo.currencyCode;
                            _this.paymentComponentSettings.numberDecimals = _this.storeInfo.numberDecimals;
                            _this.countryCode = countryCode;
                            _this.memberId = _this.memberInfo ? _this.memberInfo.memberId : null;
                            if (_this.isOrderSessionInfo) {
                                _this.updateTotalsAndShipMethod();
                            }
                        }
                    });
                    _this.getPaymentMethodsByStore();
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    };
    /**
     * @description
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.getMemberRankLevelHistory = function (orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow) {
        var _this = this;
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        if (this.memberInfo && this.memberInfo.memberId && storeInfo && storeInfo.countryId) {
            this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
                .subscribe(function (response) {
                if (response) {
                    _this.memberLevelHistory = response;
                    var memberLevelInfo = _this.memberLevelHistory
                        .find(function (memberLevel) { return memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer; });
                    var isMemberFboUpgraded = memberLevelInfo ? true : false;
                    var dateParts = _this.memberInfo.enrolmentDate ? _this.memberInfo.enrolmentDate.split('-') : _this.memberInfo.createdDate.split('-');
                    var enrollmentWindowDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
                    enrollmentWindowDate.setHours(0, 0, 0, 0);
                    enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + _this.restrictedDays);
                    var currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    _this.isFBOValidationPending = false;
                    if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                        orderRulesRequest.optinFbo = true;
                        _this.isMemberFboUpgraded = true;
                        _this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                    }
                    else {
                        _this.isMemberFboUpgraded = false;
                        _this.getBusinessOrderRules(orderRulesRequest);
                        _this.getMemberOrderRules(userInfo, false);
                    }
                }
                else {
                    _this.memberLevelHistory = [];
                    _this.isMemberFboUpgraded = false;
                    _this.isFBOValidationPending = false;
                    _this.getMemberOrderRules(userInfo, false);
                    _this.getBusinessOrderRules(orderRulesRequest);
                }
            });
        }
    };
    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.loadMemberShoppingCart = function (storeInfo) {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        }
        else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        }
        else {
            this.memberCart = null;
        }
    };
    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.getMemberDiscountPercentages = function (storeInfo) {
        var _this = this;
        this.loadMemberShoppingCart(storeInfo);
        var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        var wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        var memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(function (response) {
            _this.memberDiscountPercentage = response;
        });
    };
    //#endregion
    ServiceOrderComponent.prototype.onChanges = function (memberInfo) {
        var emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        var numberPattern = /^[0-9]+$/;
        var distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        if ((new RegExp(distributorIdPattern).test(memberInfo)) || new RegExp(numberPattern).test(memberInfo)) {
            this.memberSearchValidation = false;
            return;
        }
        else if (new RegExp(emailPattern).test(memberInfo) && !new RegExp(numberPattern).test(memberInfo)) {
            this.memberSearchValidation = false;
            return;
        }
        else {
            this.memberSearchValidation = true;
        }
    };
    ServiceOrderComponent.prototype.searchMember = function () {
        var _this = this;
        if (!this.orderFromLookup) {
            this.webOrderId = '';
        }
        this.searchReqValues = this.orderFormGroup.getRawValue();
        var fboId = this.searchReqValues.memberInfo;
        var distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        var emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        var type = '';
        type = this.searchReqValues.memberInfo.indexOf('@') > -1 ? 'email' : 'fboId';
        if (this.memberSearchValidation || this.searchReqValues.memberInfo.length === 0) {
            return;
        }
        this._orderService.getMemberInfo(fboId, type).subscribe(function (response) {
            if (response && response.memberId) {
                _this.memberInfo = response;
                if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                    _this.getMembergovernmentIdentificationsInfo(response.memberId);
                }
                _this.memberStatus = response.memberStatus;
                if (_this.memberStatus && _this.memberStatus.id) {
                    _this.isActive = (_this.memberStatus.id === +MemberStatus.Active);
                }
                else {
                    _this.isActive = false;
                }
                fboId = type == 'email' ? response.fboId : fboId;
                _this._commonService.getMemberStatus(fboId).subscribe(function (response) {
                    if (response && response.status === AccountRestrictionStatus.RESTRICTED && !_this.accountViewPermission) {
                        _this.accountRestriction = true;
                        var memberlevel = _this._commonService.getMemberLevel(_this.memberInfo.memberLevelID);
                        var memberDetails = {
                            fboId: fboId,
                            firstName: _this.memberInfo.firstName,
                            lastName: _this.memberInfo.lastName,
                            memberLevel: memberlevel
                        };
                        _this.memberDetails = memberDetails;
                        _this.orderFormGroup.controls['countryId'].setValue('');
                        _this.accountRestrictedDisable = true;
                    }
                    else {
                        _this.accountRestrictedDisable = false;
                        _this.searchMemberInfo(fboId);
                    }
                });
            }
            else {
                _this.clearAllTheForms(true, true);
                var notification = _this._translatePipe.get('order.Member Details Not Found');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    ServiceOrderComponent.prototype.closeModal = function (status) {
        this.accountRestriction = status;
    };
    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    ServiceOrderComponent.prototype.searchMemberInfo = function (fboId) {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.orderFormGroup.value.memberInfo && this.orderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    };
    /**
     * Get Member Info by EmailID or FBOID
     */
    ServiceOrderComponent.prototype.getMemberInfo = function (memberDetails) {
        var _this = this;
        var type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this._orderService.getMemberInfo(memberDetails, type).subscribe(function (response) {
            if (response && response.memberId) {
                _this.serviceOrderMemberDetails.emit(memberDetails);
                _this.messageService.setPersitedMemberId(memberDetails);
                _this.orderFromLookupEmit.emit(_this.orderFromLookup);
                _this.storeInfo = null;
                if (response.memberTitleId && response.memberTypeId && (response.memberTitleId === MemberTitleExtEnums.Novus_Customer
                    && +response.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                    response.memberTitleId = MemberTitleExtEnums.PreferredCustomer;
                }
                // Add Validation for Member Level
                _this.getMemberLevelInfo(response);
            }
            else {
                _this.clearAllTheForms(true, true);
                var notification = _this._translatePipe.get('order.Member Details Not Found');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    ServiceOrderComponent.prototype.getMemberLevelInfo = function (memberResponse) {
        this.processMemberResponse(memberResponse);
        this.accountMemberInfo = Object.assign({}, memberResponse);
    };
    ServiceOrderComponent.prototype.processMemberResponse = function (response) {
        var _this = this;
        var notification = this._translatePipe.get('order.Member Details Found');
        this.memberInfo = response;
        if (response && response.sponsorId) {
            this.refSponsorId = response.sponsorId;
        }
        this.memberInfo.enrolmentDate = this.memberInfo.lastUpgradedDate;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        else if (+response.memberTypeId === MemberTypeEnum.FPC || this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        else if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        this.orderTaxResponse = null;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        }
        else {
            this.isActive = false;
        }
        if (+response.memberTypeId === MemberTypeEnum.GUEST) {
            this.memberInfo.memberLevel = MemberType.GUEST;
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this.clearAllTheForms();
        setTimeout(function () {
            _this.getAgentAllowedCountries();
        }, 2000);
        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        var memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
    };
    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */
    ServiceOrderComponent.prototype.getWholsesaleQualifiedDetails = function (fboId, memberHomeCountry, storeInfo) {
        var _this = this;
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe(function (res) {
            try {
                if (res) {
                    _this.isWhosaleCheckNotCalculated = false;
                    if (res && res.error) {
                        _this.wholesaleCheckErrorNotifications();
                    }
                    _this.memberInfo.optin = res.optIn ? res.optIn : false;
                    _this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    // Member wholesale qualified eligibility check
                    _this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                    _this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;
                    var balance = void 0;
                    try {
                        balance = Number(res.balance);
                    }
                    catch (_a) {
                        balance = _this.distributorMaxCC;
                    }
                    if (!balance) {
                        balance = _this.distributorMaxCC;
                    }
                    _this.existingCC = balance;
                    _this.getMemberDiscountPercentages(storeInfo);
                }
            }
            catch (error) {
                _this.getMemberDiscountPercentages(storeInfo);
                _this.wholesaleCheckErrorNotifications();
            }
        }, function (error) {
            _this.getMemberDiscountPercentages(storeInfo);
            _this.wholesaleCheckErrorNotifications();
        });
    };
    ServiceOrderComponent.prototype.loadMemberBasicInfo = function (memberId) {
        var _this = this;
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe(function (res) {
                _this.memberBasicInfo = res;
                if (res && res.businessEntities) {
                    var activeBusinessEntity_1 = res.businessEntities.find(function (entity) { return entity.status === RowStatus.Active && entity.countryCodeId; });
                    var country = _this.countries && activeBusinessEntity_1 && _this.countries.find(function (country) { return country.countryId && country.countryId === activeBusinessEntity_1.countryCodeId; });
                    if (activeBusinessEntity_1 && country.isocodeThree.toLowerCase() === _this.countryCode.toLowerCase()) {
                        if (_this._orderService.isValidDate(activeBusinessEntity_1.startDate, activeBusinessEntity_1.endDate)) {
                            _this.businessEntityId = activeBusinessEntity_1.id;
                        }
                        else {
                            _this.businessEntityId = null;
                        }
                    }
                }
            }, function (error) { });
        }
    };
    /**
     * @description to display Error Message If WholesaleCheck  are not calculated
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.wholesaleCheckErrorNotifications = function () {
        this.isWhosaleCheckNotCalculated = true;
        var notification = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    };
    /**
    * Member Allowed Countries Filter
    * @param memberAllowedCountries
    */
    ServiceOrderComponent.prototype.populateCountries = function (memberAllowedCountries) {
        var _this = this;
        this.memberCountries = [];
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach(function (allowedCountry) {
                var countryObj = _this.stores
                    .filter(function (country) { return country.cspServiceOrderEnabled && allowedCountry.isoCodeThree === country.isocodeThree; })[0];
                if (countryObj) {
                    if (!(_this.memberCountries.findIndex(function (country) { return country.isoCodeThree === countryObj.isocodeThree; }) >= 0)) {
                        _this.memberCountries.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                        if (allowedCountry.homeCountry)
                            _this.homeCountry = allowedCountry.isoCodeThree;
                    }
                }
            });
            if (!this.userInfo.hasSystemRole) {
                var allowedCountry_1;
                var allowedCountries_1 = [];
                var allowedOperatingCountries = [];
                if (this.operatingCountries && this.operatingCountries.length > 0 && this.agentAllowedCountries && this.agentAllowedCountries.length > 0) {
                    allowedOperatingCountries = this.operatingCountries.filter(function (item) {
                        return _this.agentAllowedCountries.indexOf(item.operatingCountryCode) > -1;
                    });
                    if (allowedOperatingCountries && allowedOperatingCountries.length > 0 && this.memberCountries && this.memberCountries.length > 0) {
                        allowedOperatingCountries.forEach(function (operatingCountry) {
                            allowedCountry_1 = _this.memberCountries.find(function (memberCountry) { return memberCountry.isoCodeThree === operatingCountry.countryCode; });
                            if (allowedCountry_1) {
                                allowedCountries_1.push(allowedCountry_1);
                            }
                        });
                        this.memberCountries = JSON.parse(JSON.stringify(allowedCountries_1));
                    }
                    else {
                        this.memberCountries = [];
                    }
                }
                else {
                    this.memberCountries = [];
                }
            }
            this.sortTableByColumn('name');
            if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId);
                this.selectedCountry();
            }
            else if (this.createOrderInfo && this.createOrderInfo.countryId && this.shoppingBagClicked) {
                this.orderFormGroup.controls['countryId'].setValue(this.createOrderInfo.countryId);
                this.selectedCountry();
            }
            else if (this.originalOrderCountry && this.originalOrderCountry.countryId) {
                var selectedCountryDetail = this.memberCountries.find(function (country) { return country.id === _this.originalOrderCountry.countryId; });
                if (selectedCountryDetail) {
                    this.orderFormGroup.controls['countryId'].setValue(this.originalOrderCountry.countryId);
                    this.selectedCountry();
                }
                else {
                    this.showPermissionErrorMessage(this.originalOrderCountry.name);
                    return;
                }
            }
            else if (this.memberCountries.length > 0) {
                var countryObj = this.memberCountries.find(function (country) { return country.homeCountry === true; });
                if (countryObj) {
                    this.orderFormGroup.controls['countryId'].setValue(countryObj.id);
                }
                else {
                    this.orderFormGroup.controls['countryId'].setValue(this.memberCountries[0].id);
                }
                this.selectedCountry();
            }
        }
    };
    ServiceOrderComponent.prototype.sortTableByColumn = function (property) {
        var direction = 1;
        this.memberCountries.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
    };
    /**
    *
    * @param memberId get Member Addresses
    */
    ServiceOrderComponent.prototype.getMemberAddressByMemberId = function (memberId, countryId) {
        var _this = this;
        this.shippingAddressInfo = null;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(function (response) {
            _this.memberAddressDetails = [];
            _this.memberShippingDetails = [];
            if (response && response.length > 0) {
                _this.memberAddressDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                _this.memberAddressDetails = _this._commonService.sortMemberAddress(_this.memberAddressDetails);
                _this.addressSearchResult = _this.memberAddressDetails;
                if (!_this.isOrderSessionInfo && (_this.orderSession === null || !_this.orderSession.shippingAddressId)) {
                    _this.address = _this.memberAddressDetails.find(function (x) { return x.defaultAddress === true; });
                    if (_this.address) {
                        _this.address.phone = _this.address.phoneNumber;
                        _this.address.email = _this.address.email ? _this.address.email : null;
                        _this.address.isShowStateCode = _this.checkoutConfig.showStateCode;
                        _this.address.isSavedAddress = true;
                        _this.shippingAddressInfo = _this.address;
                        _this.savedAddressId = _this.address.id;
                        _this.showShippingData = true;
                        _this.constructSchemaFormUrl(_this.countryCode);
                    }
                    else {
                        if (_this.memberAddressDetails && _this.memberAddressDetails.length > 0) {
                            _this.address = _this.memberAddressDetails[0];
                            _this.shippingAddressInfo = _this.address;
                        }
                        _this.constructSchemaFormUrl(_this.countryCode);
                    }
                }
                _this.memberShippingDetails = response.filter(function (x) { return x.addressTypeId === AddressType.SHIPPING; });
                if (_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    // check for shpping address when order info is in cache
                    if (_this.orderSession.shippingAddressId) {
                        _this.address = _this.memberShippingDetails.find(function (x) { return x.id === _this.orderSession.shippingAddressId; });
                        _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                        if (_this.address) {
                            _this.address.phone = _this.address.phoneNumber;
                            _this.address.email = _this.address.email ? _this.address.email : null;
                            _this.address.isSavedAddress = true;
                            _this.shippingAddressInfo = _this.address;
                            _this.savedAddressId = _this.address.id;
                            _this.constructSchemaFormUrl(_this.countryCode);
                            _this.showShippingData = true;
                        }
                        else {
                            _this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    else {
                        _this.mapShippingAddressDetailsFromSession();
                    }
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        _this.validationsOnDeliveryPreference();
                    }
                    _this.loadproductsFromSession();
                }
            }
            else {
                if (_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(_this.orderSession.saveForFutureUse);
                    if (_this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        _this.orderFormGroup.controls['deliveryPreference'].setValue(_this.orderSession.deliveryPreference);
                        _this.constructSchemaFormUrl(_this.countryCode);
                        _this.validationsOnDeliveryPreference();
                    }
                    else {
                        if (_this.orderSession.shippingAddressId) {
                            _this.address = _this.orderSession.shippingAddressInfo;
                            _this.orderFormGroup.controls['shippingAddressId'].setValue(_this.orderSession.shippingAddressId, { onlySelf: true });
                            if (_this.address) {
                                _this.shippingAddressInfo = _this.address;
                                _this.savedAddressId = _this.address.id;
                                _this.constructSchemaFormUrl(_this.countryCode);
                                _this.address.isSavedAddress = _this.orderSession.isSavedAddress;
                                _this.showShippingData = true;
                                _this.verifiedShippingAddressId = _this.orderSession.verifiedShippingAddressId;
                                _this.address.id = _this.orderSession.shippingAddressId;
                            }
                        }
                        else {
                            _this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    // check for shpping address when order info is in cache
                    _this.loadproductsFromSession();
                }
                else {
                    if (_this.countryCode === _this.homeCountry && _this.memberInfo && _this.memberInfo.address && _this.allowMemberInfoAddress()) {
                        _this.address = _this.memberInfo.address;
                        _this.address.email = _this.memberInfo.email ? _this.memberInfo.email : null;
                        _this.address.firstName = _this.memberInfo.firstName;
                        _this.address.middleName = _this.memberInfo.middleName;
                        _this.address.lastName = _this.memberInfo.lastName;
                        _this.address.stateCode = _this.memberInfo.address.stateCode;
                        _this.address.countryCode = _this.countryCode;
                        if (!_this.address.countryId) {
                            _this.address.countryId = _this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; }).id;
                        }
                        _this.address.isShowStateCode = _this.checkoutConfig.showStateCode;
                        _this.shippingAddressInfo = _this.address;
                        _this.savedAddressId = _this.address.id;
                        _this.showShippingData = true;
                    }
                    else if (_this.memberInfo) {
                        _this.address = {};
                        _this.address.email = _this.memberInfo.email ? _this.memberInfo.email : null;
                        _this.address.firstName = _this.memberInfo.firstName;
                        _this.address.middleName = _this.memberInfo.middleName;
                        _this.address.lastName = _this.memberInfo.lastName;
                        _this.address.countryCode = _this.countryCode;
                        _this.address.countryId = _this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; }).id;
                        var notification = _this._translatePipe.get('order.Address Information for this member is not available to populate');
                        _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    if (_this.memberInfo.memberContacts && _this.memberInfo.memberContacts.length > 0) {
                        var memberContact = _this.getPhoneNumber(_this.memberInfo.memberContacts);
                        if (memberContact) {
                            _this.address.phoneType = memberContact.contactTypeID;
                            _this.address.phone = memberContact.value ? memberContact.value : null;
                        }
                    }
                    _this.constructSchemaFormUrl(_this.countryCode);
                }
            }
            if (_this.memberAddressDetails && _this.memberAddressDetails.length === 0) {
                _this.orderFormGroup.controls['shippingAddressId'].setValue('');
            }
        }, function (error) {
            _this.orderFormGroup.controls['countryId'].enable();
            var notification = _this._translatePipe.get('order.Unable to retrieve Member Addresses');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            _this.constructSchemaFormUrl(_this.countryCode);
        });
    };
    ServiceOrderComponent.prototype.allowMemberInfoAddress = function () {
        var _this = this;
        if (this.memberInfo.address.countryId && this.memberCountries) {
            var country = this.memberCountries.find(function (country) { return country.isoCodeThree === _this.countryCode; });
            return country.id === this.memberInfo.address.countryId;
        }
        return true;
    };
    ServiceOrderComponent.prototype.getPhoneNumber = function (memberContacts) {
        var phoneType = this.checkoutConfig.removeMobileField ? ContactTypeValue.PHONE : this.checkoutConfig.removePhoneField ? ContactTypeValue.MOBILE : ContactTypeValue.MOBILE;
        var phoneNumber = memberContacts.find(function (item) { return (item.contactTypeID == phoneType) && item.value; });
        return phoneNumber;
    };
    /**
   * Mapping Shipping address from session
   */
    ServiceOrderComponent.prototype.mapShippingAddressDetailsFromSession = function () {
        if (this.orderSession && this.orderSession.shippingAddressInfo) {
            this.address = this.orderSession.shippingAddressInfo;
            this.shippingAddressInfo = this.address;
            this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
            this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
            this.savedAddressId = this.address.id;
            this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
            this.address.isSavedAddress = this.orderSession.isSavedAddress;
            this.showShippingData = true;
        }
        this.constructSchemaFormUrl(this.countryCode);
    };
    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    ServiceOrderComponent.prototype.deliveryPreferenceOnChange = function () {
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.dropShipAddress = null;
        this.shippingAddressChanged = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        }
        else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
        }
        else {
            this.showDropShipPersonAddressForm = false;
        }
        this.getShipMethods();
        this.validationsOnDeliveryPreference();
        //this.updateTotalsAndShipMethod();
    };
    /**
     * update validations on delivery preference
     */
    ServiceOrderComponent.prototype.validationsOnDeliveryPreference = function () {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.getShipMethods(true);
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedpickup = undefined;
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }
    };
    /**
     * map the billing address fields
     */
    ServiceOrderComponent.prototype.mapBillingAddress = function () {
        var _this = this;
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.mailingAddress && this.mailingAddress.countryId)) {
            this.paymentComponentSettings.billingAddress = this.shippingAddressInfo || this.mailingAddress;
            var country = void 0;
            var address_1 = this.shippingAddressInfo || this.mailingAddress;
            if (address_1 && (address_1.stateCode === PaymentConstants.PuertoRico
                || address_1.stateCode === PaymentConstants.MarshallIslands
                || address_1.stateCode === PaymentConstants.VirginIslands)) {
                if (address_1.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(function (x) { return x.isocodeThree.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
                else {
                    country = this.countries.filter(function (x) { return x.isocodeTwo.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
            }
            else {
                country = this.countries.filter(function (x) { return x.countryId === address_1.countryId; })[0];
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address_1.postalCode;
        }
        else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
    };
    /**
     * On Shipping Address Selected
     */
    ServiceOrderComponent.prototype.selectedShippingAddress = function (address) {
        this.addressSearchResult = this.memberAddressDetails;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            var addressDetailId_1 = address.id;
            address.isSavedAddress = true;
            if (addressDetailId_1 && this.memberShippingDetails) {
                var shippingAddress = this.memberShippingDetails.filter(function (x) { return x.id === addressDetailId_1; });
                if (shippingAddress && shippingAddress[0]) {
                    this.pudoShippingAddressInfo = shippingAddress[0].shippingAddress;
                }
            }
            this.savedPudoAddressId = address.id;
            address.isShowStateCode = this.checkoutConfig.showStateCode;
            this.pudoShippingAddressInfo = address;
            this.pudoAddress = address;
            this.pudoAddress.phone = address.phoneNumber;
            this.pudoAddress.email = address.email ? address.email : '';
            this.showPudoPickupPersonAddressForm = true;
        }
        else {
            var addressDetailId_2 = address.id;
            address.isSavedAddress = true;
            if (addressDetailId_2 && this.memberShippingDetails) {
                var shippingAddress = this.memberShippingDetails.filter(function (x) { return x.id === addressDetailId_2; });
                if (shippingAddress && shippingAddress[0]) {
                    this.shippingAddressInfo = shippingAddress[0].shippingAddress;
                }
            }
            this.savedAddressId = address.id;
            address.isShowStateCode = this.checkoutConfig.showStateCode;
            this.shippingAddressInfo = address;
            this.address = address;
            this.address.phone = this.address.phoneNumber;
            this.address.email = this.address.email ? this.address.email : null;
            this.updateTotalsAndShipMethod();
        }
        this.showSavedAddress = false;
        this.pudoAddressSubmitted = false;
    };
    ServiceOrderComponent.prototype.prepareNewAddress = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);
            var addressObj = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    };
    /**
    * This method used to map communication preference
    */
    ServiceOrderComponent.prototype.checkContactSponsor = function () {
        var memberCommunicationPreferences = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    };
    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    ServiceOrderComponent.prototype.mapVerifiedAddressToFormFields = function (address) {
        if (address) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, address.state, address.country);
            var mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj ? stateObj.id : null,
                stateCode: stateObj ? stateObj.stateCode : null,
                countryCode: countryObj ? (countryObj.countryCode || countryObj.isocodeThree) : null,
                countryId: countryObj ? countryObj.countryId : null,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null,
                isShowStateCode: this.checkoutConfig.showStateCode
            };
            return mapAddressToFields;
        }
    };
    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    ServiceOrderComponent.prototype.useNewShippingAddress = function (addressInfo) {
        if (addressInfo) {
            var countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            var stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            var mappedAddressInfo = {
                shipToName: addressInfo.name,
                firstName: addressInfo.firstName,
                middleName: addressInfo.middleName,
                lastName: addressInfo.lastName,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                latitude: addressInfo.latitude,
                longitude: addressInfo.longitude,
                phoneType: addressInfo.phoneType,
                isShowStateCode: addressInfo.isShowStateCode,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: addressInfo.disableAddressBlock,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.pudoShippingAddressInfo = mappedAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            }
            else {
                this.shippingAddressInfo = mappedAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        }
        else {
            this.showAddressFormValidations = true;
        }
    };
    /**
     * save address method
     */
    ServiceOrderComponent.prototype.saveAddress = function (addressDetails) {
        var _this = this;
        var saveAddressRequest = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3 ? addressDetails.addressLine3 : '',
            addressLine4: addressDetails.addressLine4 ? addressDetails.addressLine4 : '',
            shipToName: addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            latitude: addressDetails.latitude,
            longitude: addressDetails.longitude,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo.userId,
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            middleName: addressDetails.middleName,
            lastName: addressDetails.lastName,
            phoneType: addressDetails.phoneType,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            disableAddressBlock: addressDetails.disableAddressBlock,
            deliveryInstruction: addressDetails.deliveryInstruction,
            email: addressDetails.email ? addressDetails.email : null
        };
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(function (response) {
            if (response && response.addressDetail) {
                if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled && _this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                    _this.pudoAddress = addressDetails;
                    _this.pudoAddress.id = response.addressDetail.id;
                    _this.savedPudoAddressId = response.addressDetail.id;
                }
                else {
                    _this.verifiedShippingAddressId = response.addressDetail.id;
                    _this.address = addressDetails;
                    _this.address.id = response.addressDetail.id;
                    // this.address.country = this.address.countryCode;
                    _this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    _this.savedAddressId = response.addressDetail.id;
                    if (_this.shipMethodId && _this.shipMethodId.nativeElement) {
                        _this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest.saveForFutureUse) {
                    _this.messageService.setAddressSaved(true);
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to Save Member Address');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    ServiceOrderComponent.prototype.reEnterShippingAddress = function () {
        this.orderFormGroup.get('shippingAddressForm').reset();
    };
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    ServiceOrderComponent.prototype.selectShippingMethod = function (shippingMethod, isDeliveryOptionChange) {
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        if (shippingMethod) {
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.getProductRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);
                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedpickup = this.orderFormGroup.value.shipMethodId;
                }
            }
            else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = 0;
                this.shippingCost = this.isOrderSessionInfo && (this.orderSession.shippingCostValue > 0 || this.orderSession.isShippingDiscountApplied) ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = 0;
                this.orginalShippingCost = 0;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        }
    };
    ServiceOrderComponent.prototype.selectPudoCollectionPoint = function (collectionPoint) {
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
            this.getShipMethods();
        }
    };
    ServiceOrderComponent.prototype.getProductRestrictions = function (shippingMethod, pickupAddress, isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        var productRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
            if (response && response.success && response.productModels) {
                _this.getRestrictedProducts(response.productModels);
                _this.taxCalculationStatus = true;
            }
            else {
                _this.taxCalculationStatus = true;
                _this.shipMethod = shippingMethod;
                _this.showSelectedShipMethod = true;
                _this.importFeeValue = _this._currencyPipe.getFormatedCurrency(0, _this.storeInfo);
                _this.shippingCost = _this.isOrderSessionInfo ? _this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                _this.originalShippingTax = shippingMethod.shippingTax || 0;
                _this.shippingTax = shippingMethod.shippingTax || 0;
                _this.orginalShippingCost = _this.memberInfo && _this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + _this.shippingTax;
                _this.orderFormGroup.patchValue({
                    originalShippingCost: _this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                _this.calculateOrderTax();
                if (!_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['shippingCostSelector'].setValue(_this.selectEnum.firstOption.toString());
                }
                if (isDeliveryOptionChange) {
                    _this.updateTotalsAndShipMethod();
                }
            }
        });
    };
    /**
     * @description this method used for preparing product restriction odel request for pickup
     * @memberof ShippingAddressNewComponent
     */
    ServiceOrderComponent.prototype.prepareProductRestrictionModelRequest = function (pickupAddress) {
        var productRestrictionModel;
        productRestrictionModel = {
            countryCode: pickupAddress.countryCode,
            stateCode: pickupAddress.stateCode
        };
        var productModel = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(function (item) {
                productModel.push({ itemNumber: item.itemNumber });
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;
    };
    ServiceOrderComponent.prototype.getShippingCost = function () {
        this.calculateOrderTax();
    };
    /**
     * Get Ship Methods By Products and Store
     */
    ServiceOrderComponent.prototype.getShipMethods = function (isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.gtePudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) || (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) && !this.dropShipDeliveryOptionDisabled) {
            var shippingOptions_1 = this.prepareShippingOptionsRequest();
            if (!shippingOptions_1.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions_1.toAddress = this.getWarehouseAddress();
            }
            if (!shippingOptions_1.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                shippingOptions_1.toAddress = this.getWarehouseAddress();
            }
            this._orderService.getShipmentService(shippingOptions_1).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if (_this.shippingAddressInfo || (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled || _this.shippingAddressInfoConfig.dropShipLocationsEnabled) || (_this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || _this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) {
                        _this.shipMethods = response;
                        _this.shippingMethods = response.shippingMethods;
                        if (_this.shippingMethods.length > 0) {
                            _this.shippingMethods.forEach(function (shipMethod) {
                                shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                shipMethod.shippingCharge = _this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, _this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (_this.isOrderSessionInfo) {
                                _this.orderFormGroup.patchValue({
                                    shippingCostSelector: _this.orderSession.shippingCostSelector,
                                    originalShippingCost: _this.orderSession.originalShippingCost,
                                    shipMethodId: _this.orderSession.shipMethodId,
                                    shippingCost: _this.orderSession.shippingCost,
                                    shippingCostPercentage: _this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: _this.orderSession.isShippingDiscountApplied
                                });
                                var shipMethodId_1 = _this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId_1 && _this.shippingMethods) {
                                    var shippingObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_1; })[0];
                                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled
                                        && shippingObj && shippingObj.pudoEnabled
                                        && _this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                        shippingObj = _this.shippingMethods.find(function (shipMethod) { return shipMethod.pudoEnabled != true; });
                                    }
                                    if (shippingObj) {
                                        _this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        _this.getShippingCost();
                                    }
                                }
                                else {
                                    _this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });
                                    if (_this.shippingMethods[0].shippingMethodId) {
                                        var firstShippingMethod = _this.shippingMethods[0];
                                        if (_this.shippingAddressInfoConfig.pudoLocationsEnabled && firstShippingMethod && firstShippingMethod.pudoEnabled) {
                                            firstShippingMethod = _this.shippingMethods.find(function (x) { return x.pudoEnabled != true; });
                                        }
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(firstShippingMethod.shippingMethodId.toString());
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(firstShippingMethod.shippingMethodId);
                                        }
                                        _this.selectShippingMethod(firstShippingMethod, isDeliveryOptionChange);
                                    }
                                }
                            }
                            else {
                                _this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });
                                if (_this.shippingMethods[0].shippingMethodId) {
                                    var shippingInfoObj = void 0;
                                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return !x.pudoEnabled; });
                                        }
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        }
                                        if (_this.selectedpickup && _this.isPickUpOptionExist && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +_this.selectedpickup; })[0];
                                        }
                                        else {
                                            if (!shippingInfoObj) {
                                                shippingInfoObj = _this.shippingMethods[0];
                                            }
                                        }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY ) {
                                        _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        if (!_this.pudoShippingMethod) {
                                            _this.getPudoShippingMethods(shippingOptions_1, response.shippingMethods, false);
                                        }
                                        else {
                                            //       this.getPudoLocations();
                                        }
                                        // }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                                        //     shippingInfoObj = this.shippingMethods[0];
                                        //     this.getPudoShippingMethods(shippingOptions, response.shippingMethods);
                                        // }
                                    }
                                    else {
                                        if (_this.selectedpickup && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +_this.selectedpickup; })[0];
                                        }
                                        else {
                                            shippingInfoObj = _this.shippingMethods[0];
                                        }
                                    }
                                    if (shippingInfoObj) {
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId.toString());
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        _this.selectShippingMethod(shippingInfoObj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            setTimeout(function () {
                                _this.orderSession = null;
                                _this.isOrderSessionInfo = false;
                            }, 2000);
                        }
                    }
                    //  this.calculateOrderTax();
                }
                else if (response && response.productModels && response.productModels.length > 0) {
                    _this.getRestrictedProducts(response.productModels);
                }
                else if (response && response.validations.length > 0) {
                    _this.shipMethodValidation = response.validations[0];
                }
                else if (response && !(response.success)) {
                    _this.shippingMethods = [];
                    _this.shippingCost = 0;
                    _this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if (_this.isDropShipOptionExist && !_this.pudoShippingMethod) {
                    _this.getDropShipPudoShippingMethods(shippingOptions_1, response.shippingMethods, false);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Ship Methods');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
        else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }
    };
    ServiceOrderComponent.prototype.getPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DROPSHIP;
            //order source only for AUT && DEU Country
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled == true; });
                    if (mappingRequired) {
                        if (_this.pudoShippingMethod) {
                            _this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        _this.getPudoLocations();
                    }
                }
            }, function (error) {
            });
        }
    };
    /**
     * this will prepare shipping options request
     */
    ServiceOrderComponent.prototype.prepareShippingOptionsRequest = function () {
        var shippingOptions = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? this.getShippingAddress() : (this.shippingAddressInfoConfig.dropShipLocationsEnabled
                && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint) : this.gtePudoPickupPersonAddress(),
            storeId: this.storeInfo.id,
            requestID: 2,
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
            priceTypeId: this.getPriceTypeId(),
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.subTotal ? this.subTotal : 0,
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: this.getPurchaseFlowId(),
            shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP ? ShippingType.DROPSHIP : ShippingType.PICKUP),
            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? true : false
        };
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.SERVICE;
        }
        return shippingOptions;
    };
    ServiceOrderComponent.prototype.getPudoDropShipPersonAddress = function (collectionPoint) {
        var address = collectionPoint;
        var dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            };
            this.pudoAddress = dropShipAddress;
            this.dropShipAddress = dropShipAddress;
        }
        return this.dropShipAddress;
    };
    ServiceOrderComponent.prototype.gtePudoPickupPersonAddress = function () {
        var address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                var mailingAddress = this.memberBasicInfo && this.memberBasicInfo.address ? this.memberBasicInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.memberBasicInfo.phone;
                            address.phoneNumber = this.memberBasicInfo.phone;
                        }
                        if (!address.email) {
                            address.email = this.memberBasicInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        }
        else {
            address = this.pudoShippingAddressInfo;
        }
        if (this.createOrderInfo) {
            this.pudoAddress = this.address;
        }
        else {
            this.pudoAddress = this.pudoShippingAddressInfo;
        }
        return address;
    };
    ServiceOrderComponent.prototype.preparePudoLocationRequest = function () {
        var _this = this;
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        var request = null;
        if (this.pudoLocationSearchForm) {
            var pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
                if (this.countries && this.storeInfo.homeIsocodeThree && pudoLocationSearchFormData.zipCode) {
                    var country = this.countries.find(function (x) { return x.isocodeThree.toUpperCase() === _this.storeInfo.homeIsocodeThree.toUpperCase(); });
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || ''
                    };
                }
            }
        }
        return request;
    };
    ServiceOrderComponent.prototype.loadPUDOLocations = function () {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        }
        else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    };
    ServiceOrderComponent.prototype.getPudoLocations = function () {
        var _this = this;
        var pudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(function (res) {
                _this.loadingPudoPickupLocations = false;
                if (res && res.collectionPoints && res.collectionPoints.length) {
                    _this.pudoLocationsNotFound = false;
                    res.collectionPoints.sort(function (x, y) { return x.distance - y.distance; });
                    _this.pudoCollectionPoints = res.collectionPoints;
                    _this.prepareBusinessHours();
                    if (_this.pudoLocationSearchForm && _this.pudoLocationSearchForm.value && _this.pudoLocationSearchForm.value.externalId) {
                        _this.selectedPudoCollectionPoint = _this.pudoCollectionPoints.find(function (x) { return x.externalId == _this.pudoLocationSearchForm.value.externalId; });
                        if (_this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && _this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                            _this.getShipMethods();
                        }
                    }
                }
                else {
                    _this.pudoLocationsNotFound = true;
                }
            }, function (error) {
                _this.loadingPudoPickupLocations = false;
                _this.pudoLocationsNotFound = true;
            });
        }
    };
    ServiceOrderComponent.prototype.prepareBusinessHours = function () {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach(function (collectionPoint) {
                if (collectionPoint && collectionPoint.openingHours) {
                    var businessHours_1 = [];
                    collectionPoint.openingHours.forEach(function (opening) {
                        if (opening && opening.hours) {
                            var hours_1 = [];
                            opening.hours.forEach(function (hour) {
                                hours_1.push({ start: hour.opens, end: hour.closes });
                            });
                            var businessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours_1
                            };
                            businessHours_1.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours_1;
                }
            });
        }
    };
    /** Products
    * @returns Products
    */
    ServiceOrderComponent.prototype.getProductModels = function () {
        // const items: any = this.orderFormGroup.get('items');
        var productModels = [];
        if (this.products && this.products.length > 0) {
            for (var index = 0; index < this.products.length; index++) {
                var product = this.products[index];
                if (product) {
                    var productModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }
            }
        }
        return productModels;
    };
    /**
     * Decrement the item Quantity
     * @returns void
     */
    ServiceOrderComponent.prototype.decrementQuantity = function (index) {
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.setFocusbyID('quantity-' + (index));
            this.updateTotalsAndShipMethod();
        }
    };
    /**
    * Increment the item Quantity
    * @returns void
    */
    ServiceOrderComponent.prototype.incrementQuantity = function (index) {
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            var product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                items.controls[index].controls['disableIncrement'].setValue(true);
            }
            else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            // items.controls[index].controls['disableIncrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
            this.updateTotalsAndShipMethod();
        }
    };
    ServiceOrderComponent.prototype.quantityChange = function (event, index) {
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    };
    /**
    * @param  {number} index
    * @returns void
    */
    ServiceOrderComponent.prototype.updateQuantity = function (event, index) {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            var items = this.orderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (event.target.value && parseInt(event.target.value, 10))) {
                    var product = items.controls[index].controls['productItem'].value;
                    if (product && event.target.value > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    }
                    else {
                        items.controls[index].controls['quantity'].setValue(event.target.value);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                this.isFocused = false;
            }
        }
    };
    /**
     * @description open/close when restricted products shown
     * @param {boolean} isOpen
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.restrictionPopupOpen = function (isOpen) {
        this.isRestrictionPopupOpened = isOpen;
    };
    /**
     * disabling Submit button
     */
    ServiceOrderComponent.prototype.disableSubmitButton = function () {
        this.taxCalculationStatus = true;
    };
    /**
     * @returns void
     */
    ServiceOrderComponent.prototype.deleteItem = function (index) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0) {
            items.removeAt(index);
        }
        setTimeout(function () {
            if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                _this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
    };
    ServiceOrderComponent.prototype.confirm = function (index) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
        // this.quickOrderNumberItemModal.hide();
    };
    ServiceOrderComponent.prototype.addItemNumber = function () {
        this.items = this.orderFormGroup.get('items');
        this.items.push(this.createItemNumberGroup());
    };
    // endregion
    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    ServiceOrderComponent.prototype.clearAllTheForms = function (clearCountry, clearShippingAddress, clearMember) {
        if (clearCountry === void 0) { clearCountry = true; }
        if (clearShippingAddress === void 0) { clearShippingAddress = true; }
        if (clearMember === void 0) { clearMember = false; }
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedpayvisionCardInfo = null;
        this.shipMethod = null;
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.memberLevelHistory = [];
        this.isMemberFboUpgraded = false;
        this.isFBOValidationPending = false;
        this.personalInformation = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.isSubmitted = false;
        this.shippingAddressInfoConfig = null;
        this.businessEntityId = null;
        this.orderFormGroup.get('items').reset();
        var arr = this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences = {
            email: null,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL && this.stores && this.stores.length > 0) {
                var countryId = this.stores.find(function (store) { return store.isocodeThree.toUpperCase() === IsoCodeThree.USA; }).id || this.stores[0].id;
                this.orderFormGroup.controls['countryId'].setValue(countryId);
                this._enrollmentMessageService.setClearGuestForm();
            }
            else {
                this.orderFormGroup.controls['countryId'].setValue('');
            }
            this.memberCountries = [];
        }
        if (clearMember) {
            this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.orderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
        }
        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DELIVERY);
            this.shippingMethods = [];
            this.memberAddressDetails = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.showDropShipPersonAddressForm = false;
    };
    /**
     * update Totals and ShipMethod
     */
    ServiceOrderComponent.prototype.updateTotalsAndShipMethod = function () {
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            var _loop_1 = function (index) {
                var product = items.controls[index].controls['productItem'].value;
                var quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    var existProduct_1 = this_1.products.filter(function (productObj) { return productObj.id === product.id; })[0];
                    if (!existProduct_1) {
                        product.quantity = quantity;
                        this_1.products.push(product);
                    }
                    else {
                        var productIndex = this_1.products.findIndex(function (item) { return item.id === existProduct_1.id; });
                        this_1.products[productIndex].quantity = this_1.products[productIndex].quantity + quantity;
                    }
                    if (this_1.appConfig && this_1.appConfig.freeShippingFPCOrder) {
                        this_1.getMemberShippingDiscountOffer(this_1.memberInfo.memberId);
                    }
                    else {
                        this_1.memberShippingDiscountOfferEligible = false;
                    }
                    var shippingAddress_1 = this_1.getShippingAddress();
                    if (shippingAddress_1 && shippingAddress_1.countryId && this_1.countries && this_1.countries.length > 0) {
                        var country = this_1.countries.find(function (x) { return x.countryId === shippingAddress_1.countryId; });
                        this_1.countryTaxInclusive = this_1.getCountryTaxInclusiveInfo(country);
                    }
                    var isEnableVATCalculation = this_1.appConfig && this_1.appConfig.enableVATCalculation;
                    var taxCalculated = this_1.appConfig.displayTaxInclusivePrice ? false : true;
                    this_1.displayPriceConfig = this_1._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this_1.storeInfo.taxInclusive, this_1.memberInfo, taxCalculated, this_1.countryTaxInclusive, this_1.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    var price = this_1.countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = product.retailPrice;
                    if (this_1.displayPriceConfig) {
                        price = this_1.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this_1.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice : product.catalogPrice);
                        retailPrice = this_1.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this_1.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this_1.subTotal = this_1.subTotal + this_1.getItemTotalSum(product);
                    this_1.retailSubTotal = 0.0;
                    this_1.totalCommissionableVolume = 0;
                    this_1.shoppingCartCount += +product.quantity;
                }
            };
            var this_1 = this;
            for (var index = 0; index < items.length; index++) {
                _loop_1(index);
            }
            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            }
            else {
                this.itemCount = this.shoppingCartCount;
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                var literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        this.getShipMethods();
                        return;
                    }
                    else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                }
                else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
            else {
                this.itemCount = 0;
            }
            this.getShipMethods();
        }
        else {
            this.gstTax = 0;
            this.pstTax = 0;
            this.shippingCost = 0;
            this.shippingTax = 0;
            this.importFeeValue = 0;
        }
    };
    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    ServiceOrderComponent.prototype.calculateSubtotalWithWholesalePrice = function (orderSubTotal) {
        var _this = this;
        var subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(function (item) {
                subTotal += ((_this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    };
    /**
 * @description formatting dob to the yyyy-mm-dd
 * @param {LegalRequirements} legalRequirements
 * @returns {LegalRequirements}
 * @memberof ServiceOrderComponent
 */
    ServiceOrderComponent.prototype.dateOfBirthFormat = function (legalRequirements) {
        var characterCheck = /[a-zA-z]/;
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.Object) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._d;
            legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                .format(DateConstants.DOBFormat);
        }
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.String) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._i;
            var dateParts = legalRequirements.dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                    .format(DateConstants.DOBFormat);
            }
            else {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format(DateConstants.DOBFormat);
            }
        }
        return legalRequirements;
    };
    /**
    * Government ID changes
    * @memberof PersonalInfoComponent
    */
    ServiceOrderComponent.prototype.governmentIdChanges = function () {
        this.invalidGovernmentId = false;
        this.governmentIdExist = false;
    };
    /**
     * @description
     * @param {*} dateMomentObj
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.convertToSpecificDateFormat = function (dateMomentObj) {
        var characterCheck = /[a-zA-z]/;
        var dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            this.fboUpgradeForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                var dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                }
                else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.fboUpgradeForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            }
            else {
                this.datePickerStartDateAt = new Date();
            }
        }
    };
    /**
     * @description
     * @param {FormControl} governmentIdControl
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.validateGovernmentId = function (governmentIdControl) {
        var _this = this;
        this.governmentIdExist = false;
        this.invalidGovernmentId = false;
        var governmentId = governmentIdControl.value;
        var isGovernmentIdValid = governmentIdControl.valid;
        if (governmentId && governmentId.length > 0 && isGovernmentIdValid) {
            this.governmentIdValidInProgress = true;
            this._documentService.validateGovernmentId(governmentId, this.countryCode, this.storeId, this.memberId)
                .subscribe(function (response) {
                _this.invalidGovernmentId = false;
                if (response && response._body === 'false') {
                    _this.governmentIdExist = false;
                }
                else {
                    _this.governmentIdExist = true;
                }
                _this.governmentIdValidInProgress = false;
            }, function (errResponse) {
                if (errResponse) {
                    _this.governmentIdExist = false;
                    _this.governmentIdValidInProgress = false;
                    var response = JSON.parse(errResponse._body);
                    if (response && response.validations && !response.statusCode
                        && response.validations.length > 0) {
                        // this.governmentIdValidations = response.validations;
                        _this.invalidGovernmentId = true;
                    }
                    else {
                        _this.invalidGovernmentId = false;
                    }
                }
            });
        }
    };
    // endregion
    /**
     * Selected Shipping Address
     */
    ServiceOrderComponent.prototype.getShippingAddress = function (address) {
        if (address === void 0) { address = null; }
        var shippingAddress = null;
        if (address) {
            shippingAddress = address;
        }
        else {
            shippingAddress = this.shippingAddressInfo;
        }
        if (shippingAddress) {
            var mappedAddress = {
                addressLine1: shippingAddress.addressLine1,
                addressLine2: shippingAddress.addressLine2,
                addressLine3: shippingAddress.addressLine3,
                addressLine4: shippingAddress.addressLine4,
                addressVerified: shippingAddress.addressVerified,
                latitude: shippingAddress.latitude,
                longitude: shippingAddress.longitude,
                city: shippingAddress.city || null,
                state: shippingAddress.stateName,
                stateCode: shippingAddress.stateCode,
                countryCode: shippingAddress.countryCode,
                country: shippingAddress.countryName,
                postalCode: shippingAddress.postalCode ? shippingAddress.postalCode.toUpperCase() : null,
                zip: shippingAddress.postalCode ? shippingAddress.postalCode.toUpperCase() : null,
                countryId: shippingAddress.countryId,
                stateId: shippingAddress.stateId,
                name: shippingAddress.shipToName,
                firstName: shippingAddress.firstName,
                middleName: shippingAddress.middleName,
                lastName: shippingAddress.lastName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ?
                    AddressType.PICKUP_PERSON : AddressType.SHIPPING,
                isShowStateCode: shippingAddress.isShowStateCode,
                phone: shippingAddress.phone ? this.getValidPhoneNumber(shippingAddress.phone) : null,
                phoneNumber: shippingAddress.phoneNumber ? this.getValidPhoneNumber(shippingAddress.phoneNumber) : shippingAddress.phone ? this.getValidPhoneNumber(shippingAddress.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                phoneType: shippingAddress.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: shippingAddress.deliveryInstruction,
                email: shippingAddress.email ? shippingAddress.email : null
            };
            return mappedAddress;
        }
        return null;
    };
    ServiceOrderComponent.prototype.getValidPhoneNumber = function (phoneNumber) {
        if (phoneNumber && this.storeInfo && this.storeInfo.foreverDirectEnabled) {
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if (phoneNumber.substring(0, 1) !== '+' && phoneNumber.substring(0, 2) !== '00') {
                phoneNumber = '+' + phoneNumber;
            }
        }
        else {
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    };
    /**
 * Selected Shipping Address
 */
    ServiceOrderComponent.prototype.getBillingAddress = function () {
        var _this = this;
        var countryId = 0;
        if (this.countries && !this.billingAddressInfo.countryId) {
            var billingCountry = void 0;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find(function (x) { return x.isocodeTwo.toLowerCase()
                        === _this.billingAddressInfo.countryCode.toLowerCase(); });
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        var stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        var billingAddress = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    };
    ServiceOrderComponent.prototype.getPickUpAddress = function () {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.pudoShippingMethod.pickUpLocation.addressType = AddressType.PICKUP;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoShippingMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.pudoShippingMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.pudoShippingMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.pudoShippingMethod.pickUpLocation.name = this.pudoShippingMethod.pickUpLocation.pickupCenterName;
            this.pudoShippingMethod.pickUpLocation.postalCode = this.pudoShippingMethod.pickUpLocation.zip;
            return this.pudoShippingMethod.pickUpLocation;
        }
        else if (this.shipMethod && this.shipMethod.pickUpLocation
            && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);
            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            return this.shipMethod.pickUpLocation;
        }
        return null;
    };
    ServiceOrderComponent.prototype.getPudoPickUpAddress = function (address, shippingMethod) {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled) &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoCollectionPoint = this.selectedPudoCollectionPoint;
            var countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            var stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            var pudoPickUpAddress = {
                addressLine1: pudoCollectionPoint.street ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) : '',
                addressLine2: pudoCollectionPoint.address2 ? pudoCollectionPoint.address2 : '',
                addressLine3: pudoCollectionPoint.address3 ? pudoCollectionPoint.address3 : '',
                addressLine4: null,
                city: pudoCollectionPoint.city,
                state: pudoCollectionPoint.state,
                stateCode: address.stateCode,
                countryCode: address.countryCode,
                country: address.country,
                county: null,
                zip: pudoCollectionPoint.zipCode,
                company: null,
                name: pudoCollectionPoint.name,
                pickupCenterName: pudoCollectionPoint.name,
                instruction: '',
                optionName: DelivaryOptionType.Pickup,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: pudoCollectionPoint.geoPoint.latitude + '',
                longitude: pudoCollectionPoint.geoPoint.longitude + '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.zipCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoPickUpAddress;
        }
    };
    /**
 *
 * @param shippingMethod
 */
    ServiceOrderComponent.prototype.getShippingMethodWarehouseAddress = function () {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    };
    /**
     * Store Ware house Address
     */
    ServiceOrderComponent.prototype.getWarehouseAddress = function () {
        var warehouseAddress = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: this.storeInfo.warehouseAddress.name ? this.storeInfo.warehouseAddress.name : null
            };
        }
        return warehouseAddress;
    };
    ServiceOrderComponent.prototype.getPurchaseFlowId = function () {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PurchaseFlowType.Retail;
        }
        else {
            return PurchaseFlowType.WholeSale;
        }
    };
    ServiceOrderComponent.prototype.getPriceTypeId = function () {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PriceType.RETAILPRICE;
        }
        else {
            return PriceType.WHOLESALEPRICE;
        }
    };
    /**
     * verifyOrderRules
     * @returns boolean
     */
    ServiceOrderComponent.prototype.verifyOrderRules = function (isBackOrderDate) {
        var valid;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        var monthlyCCValid = false;
        var thresholdCrossed = false;
        var totalPoints = this.calculateTotalPoints();
        var subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        var literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        }
        else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
            else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            }
            else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        else {
            thresholdCrossed = true;
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                }
                else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            var maxValue = void 0;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC) {
                maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                maxValue = this.orderRules.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            }
            else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }
            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }
            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                var currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                var endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
                else {
                    var createdDate = this.momentConstructor(this.memberCCOverride.effectiveStartDate)
                        .format(DateConstants.DateFormat);
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        valid.memberCCOverride = true;
                    }
                    else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            var details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC);
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    };
    ServiceOrderComponent.prototype.getLiteratureItems = function (products) {
        var _this = this;
        var literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(function (item) { return item.literature; });
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                var tripackItems = products.filter(function (item) { return _this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1; });
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    };
    ServiceOrderComponent.prototype.validateMemberMonthlyAmountLimit = function (totalPoints) {
        var purchaseLimitExceed = false;
        var memberOrderRules = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    };
    /**
     * Get total points
     */
    ServiceOrderComponent.prototype.calculateTotalPoints = function () {
        var _totalCV = 0;
        for (var i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    };
    ServiceOrderComponent.prototype.subscribeSaveAddress = function () {
        var _this = this;
        this.messageService.getAddressSaved().subscribe(function (data) {
            if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled && _this.orderFormGroup.value.deliveryPreference == _this.deliveryPreference.DROPHIP) {
                if (!_this.pudoAddress) {
                    _this.pudoAddress = {};
                }
                _this.pudoAddress.isSavedAddress = data;
            }
            else {
                if (!_this.address) {
                    _this.address = {};
                }
                _this.address.isSavedAddress = data;
            }
        });
    };
    /**
  * on click of checkout
  * @memberof CartComponent
  */
    ServiceOrderComponent.prototype.createOrder = function () {
        var _this = this;
        if (!this.orderFormGroup.value.shipMethodId) {
            this.getShipMethods();
        }
        this.verifyAddressButtonClicked = false;
        //    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);
        //     return;
        // }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
            && !this.selectedPudoCollectionPoint && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            return;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled
            && !this.selectedPudoCollectionPoint && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
            return;
        }
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                var productIds = this.products.map(function (item) { return item.id; });
                if (productIds && productIds.length) {
                    var wholesaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified
                        ? this.memberInfo.wholeSaleQualified : false;
                    var optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                    var memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    var purchaseFlowType = PurchaseFlows.PERSONAL;
                    if (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) {
                        purchaseFlowType = PurchaseFlows.RETAIL;
                    }
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                    if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DELIVERY || (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled))) {
                        this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (products) {
                            _this.outOfStockItems = _this.stockAvailabilityCheck(products);
                            if (_this.outOfStockItems.length) {
                                _this.outOfStockModal.open();
                                _this.isSubmitted = false;
                            }
                            else {
                                _this.submitOrder();
                            }
                        });
                    }
                    else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                        // pickup products stock availability check
                        var shipMethodId_2 = this.orderFormGroup.value.shipMethodId;
                        if (shipMethodId_2 && this.shippingMethods) {
                            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                if (this.pudoShippingMethod && this.pudoShippingMethod.pickUpLocation && this.pudoShippingMethod.pickUpLocation.pickUpCenterId) {
                                    shipMethodId_2 = this.pudoShippingMethod.pickUpLocation.pickUpCenterId;
                                    var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_2; })[0];
                                    if (shippingObj && shippingObj.shippingMethodId) {
                                        this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                                    }
                                    else {
                                        this.isSubmitted = false;
                                    }
                                }
                                else {
                                    this.isSubmitted = false;
                                }
                            }
                            else {
                                var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_2; })[0];
                                if (shippingObj && shippingObj.shippingMethodId) {
                                    this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                                }
                                else {
                                    this.isSubmitted = false;
                                }
                            }
                        }
                        else {
                            this.isSubmitted = false;
                            var notification = 'Pickup location not available, Please select.';
                            this._commonService.createNotification('', notification, NotificationType.ERROR);
                        }
                    }
                }
            }
        }
    };
    /**
     * @description To check stock available
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.stockAvailabilityCheck = function (products) {
        var cartProducts = this.products;
        if (cartProducts && products && products.length) {
            var noStockItems_1 = [];
            products.forEach(function (product) {
                var cartItem = cartProducts.find(function (item) { return item.id === product.id; });
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems_1.push(cartItem);
                }
            });
            return noStockItems_1;
        }
        return [];
    };
    /**  validateThreshold(): void {
         const totalPoints = this.calculateTotalPoints();
         const subTotal = this.calculateItemsSubTotal(this.storeInfo);
         if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
             totalPoints <= this.orderRules.maxValue) {
             this.thresholdCrossed = false;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
             subTotal <= this.orderRules.maxValue) {
             this.thresholdCrossed = false;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
             subTotal > this.orderRules.maxValue) {
             this.thresholdCrossed = true;
             this.cartLimitExceed = true;
         } else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
             const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
             let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                 this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
             );
             this.cartLimitExceed = details.cartLimitExceed;
             this.thresholdCrossed = details.thresholdCrossed;
             this.memberCCLimitExceeded = details.monthlyCCValid;
             this.monthlyCCValue = details.monthlyCCValue;
             this.cartLimitNotReach = details.cartLimitNotReach;
         } else {
             this.thresholdCrossed = true;
         }
     }*/
    ServiceOrderComponent.prototype.pickupStockAvailabilityCheck = function (productIds, pickUpLocationId) {
        var _this = this;
        var noStockItems = [];
        var cartProducts = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(function (response) {
                var posProducts = response;
                if (posProducts && posProducts.length > 0) {
                    posProducts.forEach(function (pickUpProduct) {
                        var cartProduct = cartProducts.find(function (product) { return product.id === pickUpProduct.productId; });
                        if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                            cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                            noStockItems.push(cartProduct);
                        }
                    });
                }
                _this.outOfStockItems = noStockItems;
                if (_this.outOfStockItems && _this.outOfStockItems.length > 0) {
                    _this.outOfStockModal.open();
                    _this.isSubmitted = false;
                }
                else {
                    _this.submitOrder();
                }
            }, function (error) {
                var notification = _this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
            });
        }
    };
    ServiceOrderComponent.prototype.closeOutOfStockForm = function () {
        this.outOfStockModal.close();
        this.isSubmitted = false;
    };
    ServiceOrderComponent.prototype.submitOrder = function (url) {
        this.isSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            if (!this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
                this.saveAddress(this.getShippingAddress());
            }
        }
        var requestUrl = '';
        this.isSubmitted = true;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        this.submitPlaceOrder(requestUrl);
    };
    /**
     * @description Clear the out of stock items and update the tax
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.clearOutOfStockItems = function () {
        var items = this.orderFormGroup.get('items');
        if (this.outOfStockItems && this.outOfStockItems.length) {
            var productIds = this.outOfStockItems.map(function (product) { return product.id; });
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    };
    /**
     * @description Remove out of stock items from cart items
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.removeOutOfStockItems = function (items, productIds) {
        productIds.forEach(function (id) {
            var productIndex = items.value.findIndex(function (product) { return product.productId === id; });
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    };
    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @memberof PersonalInfoComponent
     */
    ServiceOrderComponent.prototype.getSelectedSponserInfo = function (sponsorInformation) {
        this.sponsorInformation = sponsorInformation;
    };
    /**
     * @description this method will fire when we chaneg textbox value
     * in address block
     * @memberof PersonalInfoComponent
     */
    ServiceOrderComponent.prototype.getAddressOnInputChange = function (address) {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress && !this.shippingAddressInfo) {
            this.prepopulateShippingAddress();
        }
    };
    ServiceOrderComponent.prototype.addressChangedByUser = function (changed) {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    };
    /**
     * @description this method will prepopulate shipping address
     * @param {string} sponsorId
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.prepopulateShippingAddress = function () {
        var _this = this;
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        var address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.email = this.liveFormPersonalInfo.email;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber;
        }
        this.address = address;
        this.showAddressForm = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        setTimeout(function () {
            _this.address = _this.address;
            _this.showAddressForm = true;
        }, 500);
    };
    /**
     * @description this method will display order details
     * @param {EnrollInfo} enrollRequest
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.displayOrderSuccessDetails = function (retailResponse) {
        if (retailResponse && retailResponse.orderInfo && retailResponse.orderInfo.webOrderId) {
            retailResponse.webOrderId = retailResponse.orderInfo.webOrderId;
            retailResponse.id = retailResponse.orderInfo.id;
            this.createOrderLog(retailResponse);
            this.orderSuccess(retailResponse);
            this.isSubmitted = false;
        }
    };
    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @param {Address} mailingAddress
     * @memberof PersonalInfoComponent
     */
    ServiceOrderComponent.prototype.getMailingAddressInfo = function (address) {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
    };
    /**
     * @description
     */
    /*  validateOrderLimit(quantityUpdate: boolean): void {
        if (!this.orderRules) {
            return;
        }
        const exceedMonthlyCCPopup: any = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        const exceedMonthlyCCOverridePopup: any = this._translatePipe
            .get('order.Monthly CC limit reached');
        const orderRulesMaxValue = this.orderRules && this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
            { max: this.storeInfo.currencySymbol + ' ' + ((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue + '.00') || '0') });
        let minimumCartLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
        const maximumCartLimit: any = this._translatePipe.get('order.Cart must not exceed');
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    this.storeInfo.currencySymbol + this.orderRules.maxValue + '</b>';
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberInfo && this.memberInfo.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            } else if (this.cartLimitNotReach && !quantityUpdate) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                    this.storeInfo.currencySymbol + this.orderRules.minValue + '</b>';
                this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                this.isSubmitted = false;
            } else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
            }
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if ((this.cartLimitExceed || this.cartLimitNotReach) && !quantityUpdate) {
                    let isLiteratureValidation = this.isLiteratureValidation(this.products);
                    let invalidProductPopup: any = this._translatePipe.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                        {
                            min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                            max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                        });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            } else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            this._commonService.createNotification('', exceedMonthlyCCOverridePopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
    } */
    /**
     * @description place order
     * @param {string} requestUrl
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.placeOrder = function (requestUrl) {
        // this.validateOrderLimit(false);
        var currentCC = this.calculateTotalPoints();
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)) {
            var availableCC = this.existingCC ? this.existingCC - currentCC
                : this.distributorMaxCC - currentCC;
            var memberHomeCountry = this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length
                ? this.memberInfo.memberAllowedCountries.find(function (country) { return country.homeCountry === true; }) : null;
            var isMemberHomeCountry = memberHomeCountry && this.selectedIsoCountryCode === memberHomeCountry.isoCodeThree ? true : false;
            if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER && isMemberHomeCountry &&
                ((availableCC <= 0 || availableCC >= this.distributorMaxCC) || (this.memberInfo.wholeSaleQualified))
                && this.orderFormGroup.controls['paymentSelector'].value !== this.selectEnum.thirdOption.toString()
                && this.appConfig.fpcToFboUpgradeFlowEnable) {
                this.optInCheck = true;
            }
            else {
                this.submitPlaceOrder(requestUrl);
            }
        }
    };
    /**
     * @description
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.submitPlaceOrder = function (requestUrl) {
        var orderRequest = this.prepareOrderRequest();
        var compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
        if (compareTaxValues) {
            this.comparePriceTier(orderRequest, requestUrl);
        }
        else {
            var notification = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    };
    /**
     * @description compare tax
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.compareTax = function (orderRequest) {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
            var totalTaxAmount_1 = 0;
            orderRequest.taxMetaData.orderTaxCharges.forEach(function (tax) {
                totalTaxAmount_1 = totalTaxAmount_1 + parseFloat(tax.taxAmount.toFixed(2));
            });
            totalTaxAmount_1 = this._currencyPipe.getFormatedCurrency(totalTaxAmount_1, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount_1.toFixed(2)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    /**
     * create order log request parameter
     */
    ServiceOrderComponent.prototype.createOrderLog = function (res) {
        var _this = this;
        var orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest)
            .subscribe(function (response) {
        }, function (error) {
            _this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        });
    };
    ServiceOrderComponent.prototype.orderSuccess = function (response) {
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.hasPersistedMemberId = false;
        this.fboid = '';
        this.messageService.setPersitedMemberId(null);
        this.showShippingData = false;
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
    };
    ServiceOrderComponent.prototype.openOrderViewTab = function (weborderID) {
        var orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        this.clearTabStoreSetting();
        this.messageService.setOrderHistoryTab(orderInfo);
    };
    ServiceOrderComponent.prototype.orderPending = function (response) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                }
                else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.submitOrder(response.json().location);
            }
        }
        else {
            localStorage.removeItem('appadmin.pollCount');
        }
        localStorage.removeItem('appadmin.pollCount');
    };
    ServiceOrderComponent.prototype.prepareOrderRequest = function () {
        var _this = this;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        var orderTypeId = this.orderType.SERVICE_ORDER;
        var shippingAddress = this.getShippingAddress();
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === shippingAddress.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status */
        var memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === _this.orderFormGroup.value.shipMethodId; })[0];
        var orderRequest = {
            backDateOrder: false,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this.languageShortCode,
            languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            shippingCost: 0,
            importFeeValue: this.importFeeValue,
            shippingTax: (this.memberShippingDiscountOfferEligible ||
                (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)) ? 0 : this.shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderGroupId: this.orderFormGroup.value.orderType === this.orderType.SERVICE_ORDER
                ? this.orderType.REPLACEMENT : 2,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.getOrderSponsorId() : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            sessionGuid: this.getSessionGuid(),
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            businessEntityId: this.businessEntityId,
            sourceTypeId: 5
        };
        return orderRequest;
    };
    /**
     *  @description thi smethod used for to get t the sponsor id
     *
     */
    ServiceOrderComponent.prototype.getOrderSponsorId = function () {
        if (this.refSponsorId) {
            if (this.isEnableFboReferralId()) {
                return this.sponsorInformation.sponsorId;
            }
            return this.refSponsorId.toString();
        }
    };
    /**
   * @description
   * @memberof CommonService
   */
    ServiceOrderComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    /**
     * @description comapare price tier details for line items
     * @param {*} orderRequest
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.comparePriceTier = function (orderRequest, requestUrl) {
        var _this = this;
        var memberDetails = this.memberInfo ? this.memberInfo : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            var wholesaleQualified = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            var optin = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            var memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            var memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe(function (response) {
                if (response) {
                    if (response.priceTireName) {
                        var priceTierName_1 = response.priceTireName;
                        var isPriceTierMatched_1 = true;
                        orderRequest.orderLineItems.forEach(function (item) {
                            if (priceTierName_1 !== item.priceTierName) {
                                isPriceTierMatched_1 = false;
                            }
                        });
                        _this.checkLineItemsPriceTier(isPriceTierMatched_1, orderRequest, requestUrl);
                    }
                    else {
                        _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                    }
                }
            }, function (error) {
                _this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        }
        else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    };
    /**
     * @description check line items pricetier
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.checkLineItemsPriceTier = function (isPlaceOrder, orderRequest, requestUrl) {
        if (isPlaceOrder) {
            this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
        }
        else {
            if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                var productIds = orderRequest.orderLineItems.map(function (item) { return item.productId; });
                if (productIds && productIds.length) {
                    this.orderFormGroup.get('items').reset();
                    var arr = this.orderFormGroup.controls.items;
                    arr.controls = [];
                    this.getProductsByIds(productIds, this.storeInfo);
                    var notification = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }
        }
    };
    /**
     * @description submit Order
     * @param {*} orderRequest
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.submitOrderBasedOnPriceTierCheck = function (orderRequest, requestUrl) {
        var _this = this;
        if (orderRequest) {
            var notification_1;
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe(function (response) {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (_this.appConfig && _this.appConfig.freeShippingFPCOrder && _this.memberShippingDiscountOfferEligible) {
                            _this.removeMemberDiscountOffer(_this.memberInfo.memberId);
                        }
                        _this.orderSuccess(response.json().responseModel);
                        var sessionGuid = ((_this.memberCart && _this.memberCart.sessionGuid) || _this.memberCartSessionGuid);
                        if (sessionGuid && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST && _this.shoppingBagClicked) {
                            _this.deleteCart(sessionGuid);
                        }
                    }
                    else if (response.json().responseModel && response.json().status === 'VALIDATION-ERROR'
                        && response.json().responseModel.validations.length > 0) {
                        var exceedLimitNotification = response.json().responseModel.validations[0].message;
                        response.json().responseModel.validations.forEach(function (x) {
                            if (x.message === StatusConstants.MONTHLY_CC_EXCEEDED) {
                                notification_1 = _this._translatePipe.get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                                var errorMessage = notification_1.value + ' <b class="helvetica-bold">'
                                    + (_this.memberCCOverride && _this.memberCCOverride.cVLimit ? _this.memberCCOverride.cVLimit : _this.memberOrderCCInfo.maxCCValue) + '</b>';
                                _this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                            }
                            else {
                                notification_1 = _this._translatePipe.get('order.Unable to Process the Order');
                                _this._commonService.createNotification('', notification_1.value, NotificationType.ERROR);
                            }
                        });
                    }
                    else {
                        _this.orderPending(response);
                    }
                    _this.isSubmitted = false;
                }
            }, function (error) {
                _this.orderSessionGuid = orderRequest.sessionGuid;
                _this.getOrderDetailsByUuid(_this.orderSessionGuid, orderRequest.distrubutorId);
            });
        }
    };
    /**
* @returns OrderLineItem
*/
    ServiceOrderComponent.prototype.getOrderLineItems = function (countryTaxInclusive) {
        var _this = this;
        var lineItems = [];
        // const items: any = this.orderFormGroup.get('items');
        if (this.products && this.products.length > 0) {
            var itemLineNumber_1 = 0;
            var lineItemTax_1;
            this.products.sort(function (x, y) {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach(function (product) {
                if (product) {
                    var unitPrice = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    var wholesalePrice = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (_this.displayPriceConfig) {
                        unitPrice = _this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (_this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (_this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = _this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            _this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = _this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            _this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (_this.orderTaxResponse && _this.orderTaxResponse.cart && _this.orderTaxResponse.cart.orderLineItems
                        && _this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax_1 = _this.orderTaxResponse.cart.orderLineItems.find(function (y) { return y.itemNumber === product.itemNumber; });
                    }
                    var unitDiscountPrice = _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    var retailUnitPrice = product.retailPrice ? product.retailPrice.toFixed(2) : product.retailPrice;
                    var lineItem = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber_1,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (_this.checkoutConfig && _this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax_1 ? lineItemTax_1.salesTax : 0,
                        unitTaxablePrice: lineItemTax_1 && lineItemTax_1.taxablePrice ? lineItemTax_1.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: _this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        // totalAmount: this._currencyPipe.getFormatedCurrency(x.applicablePrice * x.quantity),
                        totalAmount: _this._currencyPipe.getFormatedCurrency(_this.getItemTotalSum(product), _this.storeInfo),
                        discountAmount: _this._currencyPipe.getFormatedCurrency(_this.calculateDiscountAmount(product, _this.displayPriceConfig), _this.storeInfo),
                        personalDiscount: _this._currencyPipe.getFormatedCurrency(((parseFloat(retailUnitPrice) * product.quantity
                            * _this.personalDiscountPercentage) / 100), _this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: _this.appConfig && _this.appConfig.calculateNetUnitPrice
                            && _this.memberInfo && _this.memberInfo.transactionalWholesaleQualified
                            && _this.memberInfo.transactionalOptin ? _this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false
                    };
                    lineItems.push(lineItem);
                }
            });
        }
        return lineItems;
    };
    /**
     * @description get FBO eligible product
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.getFBOEigibleProduct = function (product) {
        if (product.productMetaData) {
            var fboEligibilty = product.productMetaData.
                find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    };
    ServiceOrderComponent.prototype.getOrderShippings = function () {
        var orderShippings = [];
        var shippingAddressId = null;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        }
        else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        }
        var discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        var orderShipping = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod != null ? this.shipMethod.shortCode : null,
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: false,
            // shippingWaived: this.memberShippingDiscountOfferEligible ? true :
            //     ((+this.orginalShippingCost) - (+this.getOrderShippingCost())) === 0 ? false : true,
            shippingWaiverPercentage: this.memberShippingDiscountOfferEligible ? 100 :
                discountPercentage > 0 ? discountPercentage : null,
            distributionCenter: this.shipMethod != null ? this.shipMethods.distributionCenterName : null
        };
        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.isPickUpOptionExist) {
                orderShipping.distributionCenter = (this.pudoShippingMethod.pickUpLocation.pickupCenterName) ? this.pudoShippingMethod.pickUpLocation.pickupCenterName : '';
            }
            else {
                orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
            }
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    };
    ServiceOrderComponent.prototype.getAddresses = function () {
        var addresses = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            var pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }
        }
        else {
            var addrss = this.getShippingAddress();
            if (addrss && !(this.orderFormGroup.value.deliveryPreference == DeliveryPreference.DROPSHIP)) {
                addresses.push(addrss);
            }
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoPickUpAddress = this.getPudoPickUpAddress(this.pudoShippingAddressInfo, this.pudoShippingMethod);
            pudoPickUpAddress.deliveryInstruction = pudoPickUpAddress && pudoPickUpAddress.instruction ? pudoPickUpAddress.instruction : '';
            pudoPickUpAddress.email = pudoPickUpAddress.email ? pudoPickUpAddress.email : null;
            addresses.push(pudoPickUpAddress);
            if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled)) {
                if (this.pudoShippingAddressInfo) {
                    addresses.push(this.getShippingAddress(this.pudoShippingAddressInfo));
                }
            }
        }
        if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    };
    ServiceOrderComponent.prototype.calculateOrderTotal = function () {
        var totalCost = 0;
        if (this.storeInfo) {
            // tslint:disable-next-line:no-bitwise
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        return totalCost;
    };
    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    ServiceOrderComponent.prototype.calculateOrderTax = function () {
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.gstTax = 0;
        this.pstTax = 0;
    };
    ServiceOrderComponent.prototype.getTaxablePrice = function (taxablePrice, item) {
        var enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                    && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        }
        else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        }
        else {
            return taxablePrice;
        }
    };
    ServiceOrderComponent.prototype.getPriceTier = function () {
        var priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    };
    ServiceOrderComponent.prototype.addNewProductItem = function (items, index, product) {
        var itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        var itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
        var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        return items;
    };
    ServiceOrderComponent.prototype.setFocusbyID = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    };
    ServiceOrderComponent.prototype.moveToItemLevelSearchBlock = function (event) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    };
    /**
     * @description item number search in table
     * @param {*} event
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.itemLevelSearchEvent = function (event) {
        var _this = this;
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe(function (products) {
                var responseproducts = products;
                if (responseproducts.length > 0) {
                    var product_1 = responseproducts[0];
                    var isStockAvailable = _this.stockAvailable(product_1);
                    if (isStockAvailable) {
                        var items = _this.orderFormGroup.get('items');
                        if (items && items.length >= 0) {
                            var sameProductIndex = items.controls.findIndex(function (item) {
                                return item.controls['productNumber'].value === product_1.itemNumber;
                            });
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity']
                                    .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                _this.setFocusbyID('quantity-' + (sameProductIndex));
                            }
                            else {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                items = _this.addNewProductItem(items, index, product_1);
                                _this.setFocusbyID('quantity-' + (items.length - 1));
                            }
                        }
                        _this.updateTotalsAndShipMethod();
                        if (_this.orderFormGroup.controls['orderType'].value === OrderType.POS
                            || _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            _this.deliveryPreferenceOnChange();
                        }
                    }
                    else {
                        _this._commonService.createNotification('', 'Out of stock - '
                            + (product_1.name || ''), NotificationType.ERROR);
                        if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                            _this.itemLevelSearch.nativeElement.focus();
                        }
                        _this.taxCalculationStatus = false;
                    }
                }
                else {
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                    var notification = _this._translatePipe.get('order.Invalid Item Number');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                _this.itemLevelSearch.nativeElement.value = '';
            });
        }
    };
    /**
     * @description Check stock available or not
     * @param {Product} product
     * @returns {boolean}
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.stockAvailable = function (product) {
        return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
    };
    /**
     * @description auto complete search
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.onItemSelect = function () {
        var _this = this;
        var searchProduct = this.orderFormGroup.controls['itemSearch'].value;
        if (searchProduct && searchProduct.id) {
            var isStockAvailable = this.stockAvailable(searchProduct);
            if (isStockAvailable) {
                var items = this.orderFormGroup.get('items');
                if (items && items.length >= 0) {
                    this.taxCalculationStatus = true;
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productNumber'].value === _this.orderFormGroup.controls['itemSearch'].value.itemNumber; });
                    if (sameProductIndex >= 0) {
                        items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        this.setFocusbyID('quantity-' + (sameProductIndex));
                    }
                    else {
                        this.addItemNumber();
                        var index = (items.length - 1);
                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items.controls[index].controls['quantity'].value) {
                            items.controls[index].controls['quantity'].setValue(1);
                            // this.getShipMethods();
                        }
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            var typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items = this.addNewProductItem(items, index, typHeadItem);
                        }
                        this.updateTotalsAndShipMethod();
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items.length - 1));
                    }
                }
                if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                    || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.deliveryPreferenceOnChange();
                }
            }
            else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(function () {
                    if (_this.seachItemElement && _this.seachItemElement.nativeElement) {
                        _this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    };
    ServiceOrderComponent.prototype.shippingAddressSelectionChange = function () {
        this.shippingAddressInfo = this.address ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();
    };
    ServiceOrderComponent.prototype.allowOnlyNumbers = function (event) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            var value = (event.key ? event.key : '');
            var pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
     * Save Shipping Address
     */
    ServiceOrderComponent.prototype.saveShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.verifyAddressButtonClicked = true;
        this.useNewShippingAddress(address);
        setTimeout(function () {
            var addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    };
    ServiceOrderComponent.prototype.savePudoShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
        this.createOrder();
    };
    ServiceOrderComponent.prototype.showVerifyAddressMessage = function () {
        var verifyAddressError = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    };
    ServiceOrderComponent.prototype.showPermissionErrorMessage = function (countryName) {
        var verifyPermissionError = this._translatePipe.get('order.Country dont have service order permission.');
        var permissionError = '<b class="helvetica-bold">' + countryName + '</b> &nbsp;' + verifyPermissionError.value;
        this._commonService.createNotification('', permissionError, NotificationType.ERROR);
    };
    /**
     *load procducts from session
     */
    ServiceOrderComponent.prototype.loadproductsFromSession = function () {
        var _this = this;
        this.orderSession.products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                }
            }
        });
        this.updateTotalsAndShipMethod();
    };
    /**
     * map shipping Info with the shipping form
     */
    ServiceOrderComponent.prototype.mapShippingAddressToShippingInfo = function () {
        var formAddress = this.orderSession.shippingAddressForm;
        var shippingAddressForm = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        shippingAddressForm.comtrols[0].controls['email'].setValue(formAddress.email || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    };
    /**
* @returns any
*/
    ServiceOrderComponent.prototype.getOrderPaymentInfo = function () {
        var payments = [];
        var paymentMethodType;
        paymentMethodType = (this.storePaymentInfo && this.storePaymentInfo.paymentMethodName) ? this.storePaymentInfo.paymentMethodName : PaymentMethodTypes.Service_Order;
        var orderPayment = {
            savePaymentMethod: false,
            paymentAmount: this.calculateOrderTotal(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: PaymentType.Service_Order,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: null,
                paymentMethodType: paymentMethodType,
                maskedCreditCardNumber: null,
                cardHolderName: null,
                expMonth: null,
                expYear: null,
            },
            paymentECheck: null
        };
        payments.push(orderPayment);
        return payments;
    };
    /**
         * get controls of items
         */
    ServiceOrderComponent.prototype.getItemsControl = function () {
        return this.orderFormGroup.get('items');
    };
    /**
     * prevent +, -, e entering in shipping cost
     */
    ServiceOrderComponent.prototype.keyEventShippingCost = function (event) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    };
    /**
     * On paste event for member Info
     */
    ServiceOrderComponent.prototype.onPasteEvent = function () {
        var _this = this;
        setTimeout(function () {
            _this.orderFormGroup.controls['memberInfo'].setValue(_this.orderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    };
    /**
   * clear form...
   */
    ServiceOrderComponent.prototype.clearOrderForm = function (isClearRetailForm) {
        this.clearAllTheForms(true, true, true);
        var memberInfoElement = document.getElementById('memberInfo');
        if (memberInfoElement) {
            memberInfoElement.focus();
        }
        this.refSponsorId = null;
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
    };
    /**
     * get restricted products
     */
    ServiceOrderComponent.prototype.getRestrictedProducts = function (productModels) {
        var _this = this;
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach(function (product) {
            var itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            var item = _this.products.find(function (productItem) { return productItem.itemNumber === itemNumber; });
            if (item) {
                _this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    };
    /**
         * @description To Show Shipping Restriction Error message
         * @private
         * @returns {string}
         * @memberof OrderEditComponent
         */
    ServiceOrderComponent.prototype.getShippingRestrictionError = function () {
        var _this = this;
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            var stateName = this.states.find(function (x) { return x.stateCode === _this.shippingAddressInfo.stateCode; }).stateName;
            var error = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        }
        else {
            var error = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    };
    /**
     * @description sip to different address click
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.shipToDifferentAddress = function () {
        var _this = this;
        this.showSavedAddress = true;
        this.isNewCard = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = false;
        }
        setTimeout(function () {
            if (_this.memberAddressDetails && _this.memberAddressDetails.length > 0) {
                if (_this.savedAddressElement && _this.savedAddressElement.nativeElement) {
                    _this.savedAddressElement.nativeElement.focus();
                }
            }
            else {
                if (_this.addNewAddressEle && _this.addNewAddressEle.nativeElement) {
                    _this.addNewAddressEle.nativeElement.focus();
                }
            }
        }, 500);
        this.clearPudoLocationSearchData();
    };
    /**
     * @description this method will show new address form
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.addNewAddress = function () {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        }
        else if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        else {
            this.address = null;
            this.showSavedAddress = false;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    };
    /**
    * @description this method will show new pudo address form
    * @memberof ServiceOrderComponent
    */
    ServiceOrderComponent.prototype.addNewPudoShippingAddress = function () {
        var _this = this;
        this.pudoAddress = null;
        this.showSavedAddress = false;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(function () {
            _this.displayPudoAddress = true;
        }, 100);
    };
    ServiceOrderComponent.prototype.addNewDropshipPersonAddress = function () {
        var _this = this;
        this.showDropShipPersonAddressForm = true;
        this.pudoShippingAddressInfo = null;
        setTimeout(function () {
            _this.displayDropAddress = true;
        }, 100);
    };
    ServiceOrderComponent.prototype.clearPudoLocationSearchForm = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    };
    ServiceOrderComponent.prototype.clearPudoLocationSearchData = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    };
    ServiceOrderComponent.prototype.getAddressIsValid = function (isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    };
    // getPaymentMethod by Store
    ServiceOrderComponent.prototype.getPaymentMethodsByStore = function (memberTypeId) {
        var _this = this;
        var fpc5PercentEnabled = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode, this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId, this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled, false, true).subscribe(function (response) {
            if (response) {
                _this.storePaymentInfo = response;
                _this.storePaymentInfo.forEach(function (paymentMethod) {
                    if (paymentMethod.paymentMethodId === PaymentType.Service_Order) {
                        _this.service_Order_show = true;
                    }
                });
                _this.savePaymentMethod = _this.orderSession && _this.orderSession.savePaymentMethod ?
                    _this.orderSession.savePaymentMethod : false;
            }
        });
    };
    /**
   * @description get Order Min Max Business Rules
   * @memberof ServiceOrderComponent
   */
    ServiceOrderComponent.prototype.getOrderRules = function (storeInfo) {
        var _this = this;
        var userInfo = this.memberInfo;
        var isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        var orderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };
        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }
        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe(function (response) {
            if (response) {
                _this.restrictedDays = response.restrictedDays;
                _this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
            }
        }, function (error) {
        });
        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    };
    ServiceOrderComponent.prototype.getBusinessOrderRules = function (orderRulesRequest, userInfo, isFboUpgradeFlow) {
        var _this = this;
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe(function (response) {
            if (response) {
                _this.orderRules = response;
                if (isFboUpgradeFlow) {
                    _this.getMemberOrderRules(userInfo, false, null, true);
                }
            }
        }, function (error) {
        });
    };
    /**
     * To get the order details based on original order
     */
    ServiceOrderComponent.prototype.getOrderDetails = function (storeInfo) {
        var _this = this;
        if (this.webOrderId) {
            this._orderservice.getRecentOrderInformation(this.webOrderId).subscribe(function (response) {
                if (response) {
                    _this.originalOrderDetail = response;
                    _this.setPrepopulateAddress(response);
                    _this.refSponsorId = response.sponsorId;
                    _this.constructSchemaFormUrl(_this.countryCode);
                    _this.getClonedOrderDeliveryPreference();
                    var productIds = response.orderLineItems.map(function (x) { return x.productId; });
                    _this.memberInfo.optin = response.optIn;
                    _this.getProductsByIds(productIds, storeInfo);
                    _this.cloneOrderShipMethodId = _this.originalOrderDetail.orderShippings[0].shipMethodId;
                }
            }, function (err) {
            });
        }
    };
    ServiceOrderComponent.prototype.setPrepopulateAddress = function (address) {
        var _this = this;
        this.address = address.addresses[0];
        this.pudoAddress = address.addresses[0];
        this.pickupShipppingMethodName = address.addresses[0].name;
        if (address.addresses[0].email === null) {
            if (address.addresses[1]) {
                this.address.email = address.addresses[1].email;
                this.pudoAddress.email = address.addresses[1].email;
            }
        }
        if (address.addresses[0].phone === null) {
            if (address.addresses[1]) {
                this.address.email = address.addresses[1].email;
                this.pudoAddress.email = address.addresses[1].email;
            }
        }
        if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            address.addresses.forEach(function (userAddress) {
                if (userAddress.addressType == AddressType.PICKUP_PERSON) {
                    _this.pudoShippingAddressInfo = userAddress;
                    _this.pudoAddress = _this.pudoShippingAddressInfo;
                }
                else if (userAddress.addressType == AddressType.PUDO) {
                    _this.selectedPudoCollectionPoint = userAddress;
                }
            });
            this.buildPudoLocationSearchForm(this.pudoShippingAddressInfo.postalCode, this.pudoShippingAddressInfo.city, this.pudoShippingAddressInfo.addressLine1, this.pudoShippingAddressInfo.country, this.originalOrderDetail.orderShippings[0].pudoExternalId);
            this.getPudoLocations();
        }
    };
    ServiceOrderComponent.prototype.getClonedOrderDeliveryPreference = function () {
        if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
            this.showSavedAddress = false;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DROPSHIP);
        }
        else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DROPSHIP);
        }
        else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.PICKUP) {
            this.displayPudoAddress = true;
            this.showSavedAddress = false;
            this.showPudoPickupPersonAddressForm = true;
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.PICKUP);
        }
        else if (this.originalOrderDetail.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DELIVERY) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(DeliveryPreference.DELIVERY);
        }
    };
    /**
     * Get member cc overrides
     * @param memberId
    */
    ServiceOrderComponent.prototype.getMemberCCOverrides = function (memberId) {
        var _this = this;
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(function (response) {
            if (response && response.length) {
                _this.memberCCOverride = response[0];
            }
        }, function (err) {
        });
    };
    /** get Member Order rules
     * @description
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.getMemberOrderRules = function (userInfo, isBackOrderDate, requestUrl, isFboUpgradeFlow) {
        var _this = this;
        this.memberOrderCCInfo = null;
        var fromDate;
        var toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            var enrollDate = new Date(fromDate);
            var orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate, this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe(function (response) {
            if (response) {
                var memberOrderRules = response;
                var frequencyType_1 = _this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                _this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter(function (x) { return x.frequency === frequencyType_1; })[0];
                var validateOrderRule = _this.verifyOrderRules(isBackOrderDate);
                _this.upgradeFboLimitExceeded = frequencyType_1 === Constants.FREQUENCY_ABSOLUTE ?
                    validateOrderRule.purchaseLimitExceed : false;
                _this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                _this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                _this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                _this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                _this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                _this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                if (requestUrl) {
                    _this.placeOrder(requestUrl);
                }
            }
        }, function (error) {
        });
    };
    /**
     * @description savePayment methos
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.savePaymentMethodClicked = function (savePaymentMethod) {
        this.savePaymentMethod = !savePaymentMethod;
    };
    ServiceOrderComponent.prototype.gotoCheckout = function () {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            }
            else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    };
    /**
     * @description
     * @private
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.getParticipatingCountries = function (countryCode) {
        var _this = this;
        this._customerService.getParticipatingCountries(countryCode)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                var participatingCountries = response;
                var selectedCountryID = participatingCountries.map(function (item) { return item.countryId; }).join(',');
                _this.getMemberAddressByMemberId(_this.memberInfo.memberId, selectedCountryID);
            }
        });
    };
    /**
     * check member has access to place an order
     */
    ServiceOrderComponent.prototype.checkMemberAccess = function () {
        if (this.memberInfo && this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.restrictedDays > 0) {
            var enrollmentDate = void 0;
            enrollmentDate = this.memberInfo.enrolmentDate ? new Date(this.memberInfo.enrolmentDate) : new Date(this.memberInfo.createdDate);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            var currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            }
            else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            }
            else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded) {
                var restrictPlacingOrder = true;
                if ((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && !environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))) {
                    restrictPlacingOrder = false;
                }
                if (restrictPlacingOrder) {
                    var nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    var orderPlacingError = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }
            }
        }
    };
    ServiceOrderComponent.prototype.displayPurchaseLimitMessage = function (enrollmentDate) {
        var purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        var nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage, {
            maxValue: maxValue,
            endDate: nextOrderEligibleDate
        });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    };
    /**
    *
    * @param items
    */
    ServiceOrderComponent.prototype.getItemVolumeSum = function () {
        var taxAmount = 0;
        return taxAmount;
    };
    ServiceOrderComponent.prototype.trackByItem = function (index) {
        return index;
    };
    /**
    * @description this method used for allow user to enter address fields
    * @memberof PersonalInfoComponent
    */
    ServiceOrderComponent.prototype.enableAddressFields = function (block) {
        var addressFieldInfo = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    };
    ServiceOrderComponent.prototype.validateSubTotalBasedOnType = function (products, subTotal) {
        var isThresholdCrossed = true;
        var itemSubTotal = subTotal;
        var orderMinValue = this.orderRules.minValue;
        var orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        return isThresholdCrossed;
    };
    ServiceOrderComponent.prototype.isLiteratureValidation = function (products) {
        var literatureItems = this.getLiteratureItems(products);
        var isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    };
    /**
*
* @param items
*/
    ServiceOrderComponent.prototype.getItemTotalSum = function (item) {
        return this.calculateSubTotal(this.storeInfo, this.countryTaxInclusive, item, this.memberInfo, true);
    };
    /**
      * Get Total CartItems Cost.
      */
    ServiceOrderComponent.prototype.calculateSubTotal = function (store, taxInclusiveShippingCountry, item, userInfo, taxCalculated) {
        var subTotal = 0;
        if (item) {
            var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            var isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item, store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            }
            else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, isCalculateTaxExclusivePrice);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    };
    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    ServiceOrderComponent.prototype.calculateSubtotalForVatAndNonVatRegisteredUser = function (item, store, taxInclusiveShippingCountry, userInfo, taxCalculated) {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                var total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            }
            else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        }
        else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice ? item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2))) : item.catalogPrice) * item.quantity;
        }
        else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    };
    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    ServiceOrderComponent.prototype.calculateItemSubtotal = function (item, store, taxInclusiveShippingCountry, isCalcTaxExclusivePrice) {
        return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
            // tslint:disable-next-line:no-bitwise
            toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    };
    /**
     *
     */
    ServiceOrderComponent.prototype.calculateDiscountAmount = function (item, displayPriceConfig) {
        var discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice ? item.baseRetailPrice.toFixed(2) : item.baseRetailPrice) * item.quantity) -
            (parseFloat(item.catalogPrice ? item.catalogPrice.toFixed(2) : item.catalogPrice) * item.quantity);
        return discountAmount;
    };
    /**
  * Get Total CartItems Cost.
  */
    ServiceOrderComponent.prototype.calculateItemsSubTotal = function (store) {
        var itemsSubTotal = 0;
        if (store) {
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    };
    /**
       * get member shipping discount offer
       */
    ServiceOrderComponent.prototype.getMemberShippingDiscountOffer = function (memberId) {
        var _this = this;
        this._commonService.getMemberShippingDiscountOffer(memberId, this.countryCode).subscribe(function (response) {
            if (response && response.effectiveEndDate) {
                var currentDate = new Date().setHours(0, 0, 0, 0);
                var endDate = new Date(response.effectiveEndDate.split('T')[0]).setHours(0, 0, 0, 0);
                _this.memberShippingDiscountOfferEligible = currentDate <= endDate ? true : false;
            }
            else {
                _this.memberShippingDiscountOfferEligible = false;
            }
        });
    };
    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    ServiceOrderComponent.prototype.removeMemberDiscountOffer = function (memberId) {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe(function (response) {
        });
    };
    ServiceOrderComponent.prototype.calculateNetUnitPrice = function (product) {
        var netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    };
    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof ServiceOrderComponent
    */
    ServiceOrderComponent.prototype.getShippingCostForOrderSummary = function () {
        var shippingCost = 0;
        return shippingCost;
    };
    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof ServiceOrderComponent
    */
    ServiceOrderComponent.prototype.getOrderShippingCost = function () {
        return ((this.memberInfo && this.memberInfo.vatRegistered)
            || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice))
            ? this.shippingCost : (this.shippingCost + this.shippingTax);
    };
    /**
    * @description
    * @param {*} value
    * @memberof ServiceOrderComponent
    */
    ServiceOrderComponent.prototype.updateProductInCart = function (value) {
        this.updateCartProduct = value;
    };
    ServiceOrderComponent.prototype.getUserMemberId = function () {
        var memberId = null;
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            memberId = this.accountMemberInfo.memberId;
        }
        else
            memberId = 0;
        return memberId;
    };
    /**
* @returns any
*/
    ServiceOrderComponent.prototype.getSessionGuid = function () {
        var uuid = SSO.getnonce();
        return uuid;
        ;
    };
    /**
  * @description To get the order details based on sessionguid
  * @memberof ServiceOrderComponent
  */
    ServiceOrderComponent.prototype.getOrderDetailsByUuid = function (orderSessionGuid, distrubutorId) {
        var _this = this;
        if (orderSessionGuid) {
            this._orderService.getOrderDetailsUuid(orderSessionGuid, distrubutorId).subscribe(function (response) {
                if (response) {
                    if (_this.appConfig && _this.appConfig.freeShippingFPCOrder && _this.memberShippingDiscountOfferEligible) {
                        _this.removeMemberDiscountOffer(_this.memberInfo.memberId);
                    }
                    _this.createOrderLog(response);
                    _this.orderSuccess(response);
                    var sessionGuid = ((_this.memberCart && _this.memberCart.sessionGuid) || _this.memberCartSessionGuid);
                    if (sessionGuid && _this.memberTypeId && _this.memberTypeId !== MemberTypeEnum.GUEST && _this.shoppingBagClicked) {
                        _this.deleteCart(sessionGuid);
                    }
                }
                else {
                    var notification = _this._translatePipe.get('order.Unable to Process Order.');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    _this.isSubmitted = false;
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to Process Order.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
            });
        }
    };
    ServiceOrderComponent.prototype.isEnableFboReferralId = function () {
        if (this.memberTypeId == MemberTypeEnum.GUEST && this.storeInfo && this.storeInfo.enableCspFBOReferralId && this.sponsorInformation) {
            return true;
        }
        return false;
    };
    /**
     * @description Method to search address based on name
     * @memberof ServiceOrderComponent
     */
    ServiceOrderComponent.prototype.searchShippingAddress = function (event) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    };
    ServiceOrderComponent.prototype.displayParticipatingCountryAddress = function (address) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
            && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
            && address && address.countryCode && this.storeInfo.homeIsocodeThree) {
            return address.countryCode.toUpperCase() == this.storeInfo.homeIsocodeThree.toUpperCase();
        }
        return true;
    };
    ServiceOrderComponent.prototype.getPudoLocationMap = function (geoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if (environment.restrictGoogleMapNavigation) {
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                    ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    };
    ServiceOrderComponent.prototype.getAgentAllowedCountries = function () {
        var _this = this;
        var agentAllowedCountries = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                this._customerService.getOperatingCountries().subscribe(function (response) {
                    if (response) {
                        var countryIds_1 = _this.userInfo.allowedOperatingCountries.split(',');
                        agentAllowedCountries = response.filter(function (item) {
                            if (countryIds_1 && countryIds_1.indexOf(item.id.toString()) > -1) {
                                return item;
                            }
                        });
                        if (agentAllowedCountries && agentAllowedCountries.length > 0) {
                            agentAllowedCountries = agentAllowedCountries.map(function (country) { return country.value; });
                            _this.agentAllowedCountries = JSON.parse(JSON.stringify(agentAllowedCountries));
                        }
                        if (_this.memberInfo.memberAllowedCountries) {
                            _this.populateCountries(_this.memberInfo.memberAllowedCountries);
                        }
                    }
                    else {
                        _this.agentAllowedCountries = [];
                        if (_this.memberInfo.memberAllowedCountries) {
                            _this.populateCountries(_this.memberInfo.memberAllowedCountries);
                        }
                    }
                });
            }
        }
        else if (this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
    };
    ServiceOrderComponent.prototype.getPlaceOrderButtonEnabled = function () {
        var isEnablePlaceOrder;
        isEnablePlaceOrder = !((this.isActive)
            && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
                && this.shippingAddressInfo && this.shippingAddressInfo.addressVerified)
                || ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP && this.shipMethod)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
                        && this.pudoShippingMethod && this.selectedPudoCollectionPoint)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP &&
                        this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.selectedPudoCollectionPoint)))
            && (this.products.length > 0 && this.orderFormGroup.valid && this.service_Order_show) && !this.isSubmitted || (this.orderFormGroup.valid && this.verifyAddressButtonClicked));
        return isEnablePlaceOrder ? true : false;
    };
    ServiceOrderComponent.prototype.getValidationForPlaceOrderbutton = function () {
        return !(this.isActive && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && this.shippingAddressInfo && this.shippingAddressInfo.addressVerified) ||
            (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP &&
                ((this.shipMethod && !this.shippingAddressInfoConfig.pudoLocationsEnabled)
                    || (this.pudoShippingMethod && this.shippingAddressInfoConfig.pudoLocationsEnabled))))
            && this.products.length > 0 && (this.orderFormGroup.valid) && this.service_Order_show);
    };
    ServiceOrderComponent.prototype.setPUDOSuggestedAddress = function () {
        var _this = this;
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe(function (value) {
            if (value) {
                _this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                _this.getPudoLocations();
            }
        });
    };
    ServiceOrderComponent.prototype.ngOnDestroy = function () {
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    };
    ServiceOrderComponent.prototype.getMembergovernmentIdentificationsInfo = function (memberId) {
        var _this = this;
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(function (response) {
                if (response) {
                    _this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    _this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
            });
        }
    };
    ServiceOrderComponent.prototype.clearTabStoreSetting = function () {
        this.homeCountry = null;
        this.countryCode = null;
        this.storeId = null;
        this.storeInfo = null;
        this.selectedIsoCountryCode = null;
    };
    ServiceOrderComponent.prototype.getDropShipPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    // Testing Purpose .
                    //response.shippingMethods[0].pudoEnabled = true;
                    _this.dropshipPudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.dropshipPudoShippingMethod) {
                            _this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                    }
                }
            }, function (error) {
            });
        }
    };
    return ServiceOrderComponent;
}());
export { ServiceOrderComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/service-order.component.ts.pre-build-optimizer.js